{
  "partnerPortal": {
    "addDevice": {
      "onp": {
        "no": "Nein",
        "yes": "Ja",
        "yesHint": "Die Portierungsdaten kann der Kunde später bei der Aktivierung des Abos eingeben."
      },
      "quantity": {
        "decrement": "Menge verringern",
        "increment": "Menge erhöhen"
      },
      "rateSelection": {
        "dataTariffs": "Daten-Abos",
        "flatHome": "Flat Home",
        "flatMobile": "Flat Mobile",
        "label": "Tarif",
        "required": "Bitte wähle ein Abo aus."
      },
      "step1": {
        "esim": {
          "description": "Digitale SIM — keine SIM-Karte nötig."
        },
        "required": "Bitte wähle einen SIM-Typ aus.",
        "simCard": {
          "description": "Für Geräte mit SIM-Karten-Slot."
        },
        "step": "Schritt 1"
      },
      "step4": {
        "checkingCustomer": "Kundenkonto wird überprüft...",
        "existingCustomer": "Dieser Kunde ist bereits bei Digital Republic registriert. Die persönlichen Daten müssen nicht erneut eingegeben werden.",
        "hint": "Bitte den Kunden um seinen Ausweis (ID, Pass etc.), um Fehler zu vermeiden",
        "hintTitle": "Tipp"
      },
      "stepMenuLabel": "Zu einem anderen Schritt springen",
      "steps": {
        "personal-details": {
          "description": "Erfasse die Kundendaten oder unterstütze bei der ID-Verifizierung.",
          "label": "Kundendaten"
        },
        "quantity": {
          "description": "Wie viele Abos mit der gleichen Konfiguration sollen bestellt werden?",
          "label": "Anzahl der Abos"
        },
        "sim-type": {
          "description": "Wähle aus, ob der Kunde eine SIM-Karte oder eine eSIM erhalten soll.",
          "label": "SIM-Typ auswählen"
        }
      },
      "submit": "Bestellung absenden",
      "submitting": "Wird gesendet…",
      "subtitle": "Füge ein Abo für einen Kunden hinzu."
    },
    "cockpit": {
      "callToAction": "Zu den Abos",
      "description": "Entdecke unsere aktuellen Abos und Partnerkonditionen.",
      "heading": {
        "description1": "Willkommen im Vertriebspartner Portal",
        "description2": "Registriere und weise eine SIM-Karte Kunden oder Neukunden von Digital Republic zu.",
        "greeting": "Hallo Partner"
      },
      "mobileInternet": "Mobiles Internet für alle und alles"
    },
    "success": {
      "addMorePlans": "Weitere Abos hinzufügen",
      "back": "Zum Cockpit",
      "existingCustomer": {
        "partnerSupport": {
          "hint": "Falls die Identitätsprüfung noch nicht abgeschlossen ist, wird der Kunde während der Aktivierung durch den ID-Check geführt.",
          "list": {
            "1": "Im Kundenportal mit den bestehenden Zugangsdaten anmelden",
            "2": "Im Cockpit unter «Zu aktivieren» das neue Abo auswählen",
            "3": "Den Aktivierungsprozess abschliessen"
          }
        },
        "whatHappensNext": {
          "list": {
            "1": "Der Kunde erhält ggf. eine Bestätigungs-E-Mail",
            "2": "Das Abo erscheint im Cockpit unter «Zu aktivieren»",
            "3": "Der Kunde kann sich mit seinen bestehenden Zugangsdaten anmelden — kein neues Konto nötig"
          },
          "subtitle": "Das Abo wurde dem Kundenkonto hinzugefügt und wartet im Kundenportal auf die Aktivierung.",
          "title": "Das Abo ist bereit zur Aktivierung"
        }
      },
      "newCustomer": {
        "partnerSupport": {
          "hint": "Der Kunde kann diese Schritte auch später selbst durchführen.",
          "list": {
            "1": "Willkommens-E-Mail öffnen und Passwort festlegen",
            "2": "Im Kundenportal anmelden",
            "3": "Identitätsprüfung (ID-Check) mit dem Smartphone abschliessen",
            "4": "Das Abo im Cockpit unter «Zu aktivieren» aktivieren"
          }
        },
        "whatHappensNext": {
          "list": {
            "1": "Einen Link zum Festlegen des Passworts",
            "2": "Zugang zum Kundenportal",
            "3": "Das neue Abo, bereit zur Aktivierung"
          },
          "subtitle": "Der Kunde erhält in Kürze eine Willkommens-E-Mail mit allem, was er für den Einstieg braucht.",
          "title": "Der Kunde erhält eine E-Mail"
        }
      },
      "partnerSupport": {
        "subtitle": "Bitte unterstütze den Kunden bei folgenden Schritten im Kundenportal:",
        "title": "Dem Kunden bei der Aktivierung helfen"
      },
      "successMessage": "Bestellung erfolgreich übermittelt!"
    },
    "welcomeScreen": {
      "animationText": "Let’s get started, welcome",
      "descriptionText": "Aktiviere eSIMs & SIM-Karten für deine Kunden. Informiere dich \n<0>hier über unsere Abos</0>. Digital Republic aktiviert eSIMs in Minuten, ganz ohne Wartezeit.",
      "title": "Einloggen"
    }
  },
  "portal": {
    "Error": {
      "eSimError": "eSIM Infos konnten nicht geladen werden. Bitte später erneut versuchen."
    },
    "add-device": {
      "blockedModal": {
        "viewBills": "Zu den Rechnungen"
      },
      "deleteBasket": {
        "title": "Deine Auswahl wird komplett gelöscht"
      },
      "esimInfoModal": {
        "benefits": {
          "instant": "Sofortige Aktivierung ohne Warten auf eine SIM-Karte",
          "multiTariff": "Mehrere Abos auf einem Gerät möglich",
          "noSwap": "Kein SIM-Karten-Wechsel nötig"
        },
        "confirm": "eSIM generieren",
        "description": "Eine eSIM (embedded SIM) ist eine digitale SIM-Karte, die fest in deinem Gerät eingebaut ist. Du benötigst keine SIM-Karte mehr.",
        "requirementText": "Dein Gerät muss eSIM-fähig sein (z.B. iPhone XS oder neuer, Samsung Galaxy S20 oder neuer).",
        "requirementTitle": "Voraussetzung",
        "title": "Was ist eine eSIM?"
      },
      "heading": "Abo hinzufügen",
      "invalidBasket": {
        "confirm": "Neu starten",
        "description": "Dein aktueller Warenkorb ist nicht mehr gültig. Wir löschen ihn und starten den Vorgang neu.",
        "title": "Warenkorb ungültig"
      },
      "overflowMenuLabel": "Weitere Aktionen",
      "simSelection": {
        "generateEsimLink": "Keine SIM-Karte? Direkt eSIM generieren",
        "reasons": {
          "IDCheckOpen": "Dein ID Check ist noch nicht abgeschlossen.",
          "TooManySIMs": "Du hast die maximale Anzahl an SIM Karten erreicht."
        }
      },
      "steps": {
        "checkout": {
          "description": "Überprüfe deine Details, bevor du das Onboarding abschliesst.",
          "label": "Abschluss"
        },
        "number-porting": {
          "description": "Die Portierung deiner Schweizer Rufnummer von deinem bisherigen Anbieter ist gratis und nur mit einem unserer Flat Mobile-Abos möglich.",
          "label": "Rufnummer mitnehmen"
        },
        "rate-selection": {
          "label": "Abo Auswahl"
        },
        "sim-selection": {
          "label": "SIM Typ auswählen"
        }
      },
      "subheading": "Füge deinem Cockpit hier ein weiteres Abo hinzu, indem du eine SIM-Karte oder eine eSIM aktivierst.",
      "success": {
        "fraudCheckInfo": "Wir überprüfen deine Angaben. Das sollte wenige Minuten dauern. Danach musst du den ID-Check durchführen.",
        "info": "Wir bereiten den nächsten Schritt für deine neue SIM vor.",
        "title": "Vielen Dank für deine Bestellung!"
      }
    },
    "authenticator": {
      "app": {
        "setup": {
          "step1": {
            "copied": "Dein Code wurde kopiert.",
            "copy-error": "Fehler beim Kopieren des Codes.",
            "description": "Falls du es noch nicht getan hast, lade eine Authenticator-App herunter. Für eine Liste der unterstützten Apps und detaillierte Einrichtungsanleitungen, besuche bitte unsere <FAQ/>. Nachdem du die App installiert hast, öffne diese und scanne mit der App den angezeigten QR-Code.",
            "enter-key-manually": "Schlüssel manuell eingeben",
            "faqOn2faApps": "FAQ zu 2FA-Apps",
            "faqUrl": "https://support.digitalrepublic.ch/de/support/solutions/articles/33000290333",
            "show-qr-code": "QR-Code anzeigen",
            "title": "1. QR-Code scannen",
            "your-manual-key": "Dein manueller Schlüssel:"
          },
          "step2": {
            "description": "Nachdem du den QR-Code gescannt oder den Schlüssel manuell eingegeben hast, generiert deine App einen 6-stelligen Verifizierungscode. Gib diesen unten ein, um die Einrichtung zu verifizieren.",
            "invalidCode": "Ungültiger Code",
            "title": "2. Bestätigungscode eingeben"
          }
        }
      },
      "backupCodes": {
        "copy": "Codes kopieren",
        "copyError": "Codes konnten nicht kopiert werden.",
        "copySuccess": "Codes kopiert",
        "description": "In der Box unten findest du deine persönlichen Wiederherstellungscodes. Diese Codes benötigst du, falls du dein Gerät mit der Authenticator App verlierst oder keinen Zugriff mehr darauf hast. Bitte notiere dir diese Codes oder lade sie herunter und verwahre sie an einem sicheren Ort.  \n \nDie Codes ermöglichen dir dein Konto wiederherzustellen, oder eine Authenticator App auf deinem neuen Gerät einzurichten. Jeder Code kann nur einmal verwendet werden.",
        "download": "Codes herunterladen",
        "downloadSuccess": "Codes heruntergeladen",
        "error": "Fehler beim Bestätigen deiner 2FA Konfiguration. Versuche es erneut.",
        "nameRequired": "Bitte gib deinen Namen ein.",
        "nameWrong": "Bitte unterschreib mit deinem registrierten Namen.",
        "proceedWithSteps": "Fahre mit den folgenden Schritten fort",
        "steps": {
          "1": {
            "description": "Stelle sicher, dass du deine Wiederherstellungscodes notiert oder an einem sicheren Ort gespeichert hast. Nur du solltest auf diese Codes zugreifen können.",
            "title": "1. Kopiere und speichere deine Codes sicher"
          },
          "2": {
            "placeholder": "Gib „{{name}}“ ein, um zu bestätigen",
            "title": "2. Bestätige mit deinem Namen, dass du deine Wiederherstellungscodes gesichert hast"
          }
        },
        "success": "Zwei-Faktor-Authentifizierung erfolgreich eingerichtet.",
        "title": "Fast geschafft",
        "uniqueRecoveryCodes": "Persönliche Wiederherstellungscodes"
      },
      "sms": {
        "enterNumber": {
          "description": "Bitte gib die Handynummer an, über die du die SMS mit deinen Bestätigungscodes erhalten möchtest.",
          "label": "Handynummer",
          "sendCode": "Code senden",
          "title": "Gib deine Handynummer ein"
        },
        "verification": {
          "description": "Ein Code wurde an {{number}} gesendet. Gib den Code unten ein, um deine Handynummer zu bestätigen und die Einrichtung abzuschliessen. ",
          "digit": "Ziffer {{index}} von {{count}}",
          "label": "Bestätigungscode",
          "resend": "Code erneut senden",
          "resendToast": {
            "error": "Fehler beim Senden des Codes. Versuche es bitte erneut.",
            "success": "Code erfolgreich gesendet."
          },
          "secondsLeft": "in {{count}} Sekunden",
          "title": "Gib den Bestätigungscode ein"
        }
      },
      "verifyEmail": {
        "confirmCode": "Code bestätigen",
        "confirmEmailAddress": "Bestätige deine E-Mail-Adresse",
        "description": "Um deine Registrierung abzuschliessen, müssen wir deine E-Mail-Adresse verifizieren. Bitte gib den Code ein, den wir an {{email}} gesendet haben.",
        "enterEmailAgain": "E-Mail-Adresse erneut eingeben",
        "error": {
          "invalidCode": "Ungültiger Code",
          "maxCodes": "Maximale Anzahl aktiver Codes erreicht",
          "maxRetry": "Maximale Anzahl an Verifizierungsversuchen erreicht"
        },
        "success": "E-Mail-Adresse erfolgreich verifiziert",
        "successResend": "Code wurde gesendet",
        "wrongMailAddress": "Ist die E-Mail-Adresse falsch?"
      }
    },
    "bills": {
      "downloadMultiple": "Mehrere herunterladen",
      "download_one": "{{count}} herunterladen",
      "download_other": "{{count}} herunterladen",
      "list": {
        "downloadBill": "Rechnung herunterladen",
        "empty": "Es liegen noch keine Rechnungen vor.",
        "headline": "Deine Rechnungen",
        "status": {
          "canceled": "Storniert",
          "due": "Offen",
          "paid": "Bezahlt",
          "reminder": "Mahnung"
        },
        "tableHeaders": {
          "amount": "Betrag",
          "date": "Datum",
          "deselectAllBills": "Alle Rechnungen auf dieser Seite abwählen.",
          "invoiceFor": "Rechnung",
          "number": "Rechnungs­nummer",
          "open": "Öffnen",
          "selectAllBills": "Alle Rechnungen auf dieser Seite auswählen."
        }
      },
      "zipName": "{{count}} Rechnungen von Digital Republic"
    },
    "bulk-sim-activation": {
      "activationFailed": "Aktivierung fehlgeschlagen",
      "csvError": "Die CSV muss Spalten für ICCID, PUK und Alias enthalten (z. B. Inv | ICCID, PUK 1, Alias).",
      "csvFile": "CSV-Datei",
      "customer": {
        "email": "E-Mail",
        "heading": "Angemeldeter Benutzer",
        "id": "Kundennummer",
        "loading": "Kunde wird geladen...",
        "notAvailable": "k. A.",
        "paymentMode": "Zahlungsart",
        "unknown": "Unbekannter Kunde"
      },
      "description": "Lade eine CSV hoch und führe die SIM-Aktivierung nacheinander über die Onboarding-Endpunkte aus.",
      "heading": "Massen-SIM-Aktivierung",
      "manualPaymentRequired": {
        "description": "Die Aktivierung ist nur für Kunden mit der Zahlungsart Manuell möglich.",
        "title": "Manuelle Zahlung erforderlich"
      },
      "startActivation": "Aktivierung starten ({{count}} ausstehend)",
      "status": {
        "failed": "Fehlgeschlagen",
        "pending": "Ausstehend",
        "running": "Läuft",
        "success": "Erfolgreich"
      },
      "steps": {
        "addBasketEntry": "Warenkorbposition wird hinzugefügt",
        "addOption": "Option wird hinzugefügt",
        "checkSim": "SIM wird geprüft",
        "checkout": "Checkout",
        "idle": "in Warteschlange",
        "saveBasket": "Warenkorb wird geladen",
        "setAlias": "Alias wird gesetzt",
        "setDevice": "Gerät wird gesetzt",
        "setICCID": "ICCID/PUK wird gesetzt"
      },
      "stopAfterCurrent": "Nach aktueller Zeile stoppen",
      "table": {
        "alias": "Alias",
        "empty": "Keine CSV-Daten geladen."
      }
    },
    "cockpit": {
      "dashboard": {
        "quickLinks": {
          "showAll": "Alle anzeigen",
          "showMoreAbos_one": "+{{count}} weiteres Abo anzeigen",
          "showMoreAbos_other": "+{{count}} weitere Abos anzeigen",
          "title": "Deine Abos"
        },
        "resources": {
          "fwb": {
            "button": "Jetzt Freunde einladen",
            "text": "Lade Freunde ein und spare bis zu 30% auf deine Tarife."
          }
        },
        "todos": {
          "addPaymentMethod": "Hinterlege ein Zahlungsmittel",
          "fwbMobileAbo": "Buche ein Mobile Abo, um in deiner Friends Gruppe zu bleiben",
          "kyc": {
            "dataMismatch": "Korrigiere deine Daten gemäss Ausweis",
            "errorProcessingDocs": "Lade deinen Ausweis erneut hoch",
            "errorProcessingSelfie": "Wiederhole dein Selfie-Video",
            "fraudCheckPending": "Deine Bestellung wird geprüft",
            "idUncomparable": "Wiederhole deinen ID-Check",
            "invalidDocument": "Lade einen gültigen Ausweis hoch",
            "maxAttempts": "Kontaktiere den Support",
            "open": "Verifiziere deine ID",
            "pending": "Dein ID-Check wird geprüft",
            "underaged": "Prüfe die Altersvoraussetzungen"
          },
          "payOpenBills": "Begleiche deine offenen Rechnungen",
          "title": "Noch zu erledigen"
        }
      },
      "deviceList": {
        "noSearchResults": "Für deine Suche gibt es leider keine Ergebnisse",
        "row": {
          "green": "Dieses Abo ist aktiv.",
          "grey": "Dieses Abo ist inaktiv.",
          "openDevice": "{{alias}} öffnen",
          "red": "Dieses Abo wurde gesperrt.",
          "yellow": "Dieses Abo ist aktiv und wird pausiert."
        }
      },
      "filter": {
        "activity": "Aktivität",
        "activity-labels": {
          "all": "Alle",
          "mobileAbo": "Mobile Abo"
        },
        "additionalColumns": "Zusätzliche Spalten",
        "application": "SIM Typ",
        "apply": "Filter anwenden",
        "dropdowns": {
          "chooseColumns": "Spalten auswählen",
          "column": "Spalte",
          "simType": {
            "placeholder": "SIM-Typ"
          }
        },
        "openFilters": "Filter öffnen",
        "resetFilters": "Filter zurücksetzen",
        "searchBar": {
          "placeholder": "Suche eingeben",
          "toggle": "Suche öffnen"
        },
        "status-labels": {
          "activeLimited": "Wird pausiert",
          "onpPending": "Nummernportierung ausstehend"
        },
        "title": "Filter"
      },
      "heading": {
        "greeting": "Hi {{name}}!"
      },
      "id-banner": {
        "open": {
          "button": "Zum ID-Check"
        }
      },
      "idCheck": {
        "button": "Zum ID Check",
        "info": "Nach Schweizer Recht müssen wir deine Identität verifizieren, bevor wir deine SIM aktivieren können. Bitte prüfe die folgenden Voraussetzungen und Informationen, bevor du mit dem ID-Check startest.",
        "infoFromOrder": "Nach Schweizer Recht müssen wir deine Identität verifizieren, bevor wir deine neue SIM aktivieren können. Bitte prüfe die folgenden Voraussetzungen und Informationen, bevor du mit dem ID-Check startest.",
        "internationalCallsWarning": "Anrufe im und ins Ausland sind nur möglich, wenn ein in der Schweiz ausgestelltes Dokument (Pass, ID oder Ausweis außer N) verwendet wurde und eine Schweizer Adresse hinterlegt ist.",
        "prep": {
          "noTablets": "Tablets werden nicht unterstützt",
          "privacy": "Wir behandeln deine Daten sorgfältig und gemäss Schweizer Recht",
          "recommendedBrowsers": "Aktuelles Betriebssystem (Safari oder Chrome)",
          "validIdDocument": "Gültiges ID-Dokument"
        },
        "title": "ID Check",
        "titleFromOrder": "Letzter Schritt für deine neue SIM"
      },
      "kycSection": {
        "idCheckFailed": {
          "text": "Deine Daten konnten nicht verifiziert werden. Bitte lade deinen Ausweis erneut hoch.",
          "title": "Fehlgeschlagener ID-Check"
        },
        "links": {
          "maxAttempts": "https://support.digitalrepublic.ch/de/support/tickets/new",
          "underaged": "https://support.digitalrepublic.ch/de/support/solutions/articles/33000269430-kann-ich-auch-ein-abo-f%C3%BCr-mein-minderj%C3%A4hriges-kind-abschliessen-"
        }
      },
      "managementTile": {
        "details": {
          "sections": {
            "autoRenewal": {
              "buttons": {
                "confirm": "Bestätigen"
              },
              "disable": {
                "description_one": "Nach Ablauf der <strong>Restzeit von einem Tag</strong> wird dieses Abo pausiert: ",
                "description_other": "Nach Ablauf der <strong>Restzeit von {{count}} Tagen</strong> wird dieses Abo nicht mehr automatisch erneuert: ",
                "goodToKnow": "Du kannst es zu jedem Zeitpunkt wieder aktivieren.",
                "successMessage": "Das Abo wird pausiert.",
                "successorWarning": "Dein zuvor ausgewähltes Folgepaket <strong>{{ flatName }}</strong> wird nicht aktiviert.",
                "title": "Abo pausieren"
              },
              "enable": {
                "description": "Das folgende Abo läuft <strong>alle {{days}} Tage</strong> weiter: ",
                "nextBillDescription": "Dein Abo wird ab dem nächsten Rechnungsmonat berechnet. Heute zahlst du nichts.",
                "title": "Abo reaktivieren"
              }
            },
            "details": {
              "changeEsim": {
                "qrCodeDone": "Dein eSIM Profil wurde erstellt. In 5 bis 10 Minuten wirst du eine E-Mail mit dem dazugehörigen QR-Code erhalten. Beachte, dass der QR-Code innerhalb von 24 Stunden auf deinem Endgerät aktiviert werden muss.",
                "qrCodeTitle": "QR-Code Scannen",
                "waitingText": "Deine eSIM wird generiert, das dauert einige Minuten. Der QR Code erscheint hier, sobald er generiert wurde."
              },
              "deviceDetails": "Abodetails",
              "esimHint": "Aktiviere diese SIM-Karte als eSIM",
              "installOnThisDevice": {
                "title": "eSIM auf diesem Gerät installieren"
              },
              "instructionsLinkText": "Anleitung ansehen",
              "networkReset": {
                "confirmationText": "Falls du Netzwerk Probleme mit deiner SIM hast, kann es helfen, diese zurückzusetzen und neuzustarten.<0>Nach dem du die Handlung bestätigst, empfehlen wir:</0>",
                "error": "Reset wurde nicht erfolgreich gestartet.",
                "label": "Netzwerk Reset",
                "link": "Reset",
                "reasons": {
                  "openEsimChange": "Dein eSIM-Profil wird gerade übertragen, bitte warte.",
                  "openEsimReset": "Dein eSIM-Profil wird gerade neu geladen, bitte warte.",
                  "openNetworkReset": "Ein Netzwerk Reset läuft bereits, bitte warte.",
                  "openONP": "Deine Nummer wird portiert.",
                  "openOrder": "Ein anderer Vorgang läuft gerade ab, bitte warte.",
                  "openSpeedAndLock": "Derzeit nicht möglich, bitte warten.",
                  "simCancelled": "Deine Paket wurde storniert.",
                  "simInactive": "Deine SIM Karte ist inactive.",
                  "simLocked": "Deine SIM Karte ist gesperrt.",
                  "simTerminated": "Deine SIM Karte wird terminiert."
                },
                "recommendations": {
                  "reboot": "starte dein Gerät neu",
                  "rebootWatchSim": "wenn du eine WatchSIM gebucht hast, starte auch dieses Gerät neu",
                  "remove": "im Fall einer physischen SIM-Karte, entnehme es aus dem Gerät und setze es wieder ein",
                  "wait": "15 Minuten Wartezeit bevor die Verbesserungen eintreten"
                },
                "success": "Reset wurde erfolgreich gestartet.",
                "text": "Falls du Netzwerk Probleme mit deiner SIM hast, kann es helfen, diese zurückzusetzen und neuzustarten.",
                "title": "Troubleshooting"
              },
              "reasons": {
                "StatusNotAllowed": "Bevor du diese Aktion durchführst, musst du deine eSIM aus deinem Gerät löschen.",
                "noAutoRenew": "Das Abo ist pausiert.",
                "noMoreActions": "Maximal Anzahl eSIM (eSIM Umwandlung).",
                "packageOrderInProgress": "Es läuft bereits eine Paketbestellung.",
                "simFixedService": "SIM hat einen festen Service-Typ.",
                "simInactive": "SIM ist inaktiv.",
                "simNoActivePackage": "Kein aktives Paket gebucht.",
                "simSuspended": "SIM ist temporär gesperrt.",
                "simTerminated": "Vertrag wurde beendet.",
                "wrongSimType": "Falscher SIM Typ."
              },
              "registrationDetails": {
                "activationCode": "Aktivierungscode",
                "addressCopied": "SM-DP+ Adresse kopiert",
                "addressCopyError": "Die SM-DP+ Adresse konnte nicht kopiert werden.",
                "codeCopied": "Aktivierungscode kopiert",
                "codeCopyError": "Der Aktivierungscode konnte nicht kopiert werden.",
                "completeActivationCode": "Vollständiger Aktivierungscode",
                "completeCodeCopied": "Vollständiger Aktivierungscode kopiert",
                "completeCodeCopyError": "Der vollständige Aktivierungscode konnte nicht kopiert werden.",
                "hideCode": "Code ausblenden",
                "infoText": "Kopiere den Code und gib ihn manuell in deinem Gerät ein, um deine eSIM zu aktivieren.",
                "invalidCode": "Der Aktivierungscode für diese eSIM ist ungültig.",
                "missingMatchingId": "Es liegt aktuell kein Aktivierungscode für diese eSIM vor.",
                "showCode": "Code manuell eingeben",
                "smdpPlusAdress": "SM-DP+ Adresse"
              },
              "reloadEsim": {
                "button": "Neu laden",
                "screens": {
                  "confirm": {
                    "text": "Bist du sicher, dass du deine eSIM erneut aktivieren möchtest? <br><br>Du kannst deine eSIM anschliessend in den Netzwerkeinstellungen deines Geräts erneut verbinden. <br><br>Nähere Informationen zur Aktivierung einer eSIM findest du in unserem Supportportal.",
                    "title": "eSIM neu laden"
                  }
                },
                "text": "Wenn du dein eSIM-Profil auf deinem Gerät gelöscht hast, kannst du hier ein neues laden.",
                "title": "eSIM Profil neu laden"
              },
              "scanQRCode": "QR-Code scannen",
              "scanQRCodeText": "Scanne deinen QR-Code ein, um dieses Gerät final zu aktivieren und alle Vorteile nutzen zu können.",
              "simDetails": "SIM Details",
              "switchFromPhysicalToEsim": {
                "screens": {
                  "confirm": {
                    "text": "Du hast eine SIM-Karte in deinem Gerät und möchtest auf eSIM wechseln?<br><br>Stelle sicher, dass dein Gerät <0>eSIM-fähig</0> ist und wechsle dann mit einem Klick zu einer eSIM.",
                    "title": "Auf eSIM wechseln"
                  }
                }
              },
              "transferEsim": {
                "button": "Transferieren",
                "screens": {
                  "confirm": {
                    "text": "Bist du sicher, dass du deine eSIM auf einem neuen Gerät aktivieren möchtest? <br><br>Beachte, dass die eSIM auf dem aktuellen Gerät unmittelbar deaktiviert wird. Auf dem neuen Gerät kannst du anschliessend dein bestehendes eSIM Profil neu laden. <br><br>Nähere Informationen zur Aktivierung einer eSIM findest du auf unserem Supportportal.",
                    "title": "eSIM transferieren"
                  }
                },
                "text": "Wenn du dein eSIM-Profil auf ein neues Gerät übertragen möchtest, transferiere dieses hier.",
                "title": "eSIM Profil transferieren"
              }
            }
          }
        },
        "roaming": {
          "addOption": {
            "countryDropdownLabel": "Reiseziel",
            "countryList": "Alle Pakete sind 365 Tage gültig. Schau dir hier die <0/> an.",
            "errorWait": "Zur Zeit ist die Buchung noch nicht möglich. Bitte warte einige Minuten und versuche es erneut.",
            "noPackagesForDestination": "Für dieses Reiseziel ist kein Roaming-Paket verfügbar.",
            "packagesTitle": "Roaming Pakete",
            "selectCountryHint": "Wähle dein Zielland aus, um die passenden Roaming Pakete rauszufiltern",
            "selectPackageHint": "Wähle direkt dein gewünschtes Roaming Paket aus.",
            "stepLabel": "Paketauswahl",
            "title": "Roaming hinzufügen",
            "volume": "Datenvolumen"
          },
          "card": {
            "bookedPackagesTitle": "Gebuchte Pakete",
            "dataUsageGeneric": "Datenverbrauch",
            "mobileAboTitle": "In deinem Abo enthalten",
            "noActivePackage": "Keine Roaming-Pakete aktiv",
            "selectPackage": "Paket wählen"
          },
          "checkout": {
            "internationalCallPermissionHint": {
              "description": "Derzeit hast du keinen Zugang zu den enthaltenen Telefonie-Minuten im und ins Ausland. Um diese nutzen zu können, muss ein von der Schweiz ausgestelltes Ausweisdokument in deinem Kundenkonto hinterlegt sein (Pass, ID, C-, B-, F- oder S-Ausweis). Wenn du ein solches Dokument besitzt, kannst du dieses über unseren Support hinterlegen lassen. Die enthaltenen Roaming-Daten kannst du bereits jetzt, auch ohne dieses Ausweisdokument, verwenden.",
              "title": "Eingeschränkte Roaming-Features"
            },
            "once": "Einmalig",
            "roamingOption": "Roaming Paket",
            "stepLabel": "Abschluss",
            "success": "Buchung war erfolgreich.",
            "title": "Roaming buchen"
          },
          "inAdditionToSubscription": "Zusätzlich zu deinem Abo:",
          "includedInSubscription": "In deinem Abo enthalten:",
          "package": "Paket {{index}}",
          "roamingCallHint": {
            "text": "Anrufe von der Schweiz ins Ausland sind nur für folgende Länder inklusive: Andorra, Belgien, Dänemark, Deutschland, Färöer, Finnland, Frankreich, Gibraltar, Griechenland, Grönland, Guernsey, Irland, Island, Isle of Man, Italien, Jersey, Kanada, Liechtenstein, Luxemburg, Malta, Monaco, Niederlande, Norwegen, Österreich, Portugal, San Marino, Schweden, Spanien, USA, Vatikan, Vereinigtes Königreich, Zypern.",
            "title": "Anrufe von der Schweiz ins Ausland"
          },
          "showOption": {
            "active": {
              "callsToAndFromAbroad": "Anrufe EU/USA",
              "dataUsage": "Data EU/USA",
              "notAllowed": "Derzeit nicht verfügbar.",
              "notAllowedTooltip": "Zur Nutzung von Roaming-Telefonie muss ein Zahlungsmittel hinterlegt sein und ein von der Schweiz ausgestelltes Identitätsdokument (Pass/ID oder Ausländerausweis) beim ID Check verwendet werden.",
              "overspentCalls": "Deine internationale Anrufe sind aufgebraucht und es gelten die <0>regulären Tarife</0>.",
              "overspentCallsLink": "https://digitalrepublic.ch/wp-content/uploads/2024/05/Preisliste_DE-3.pdf",
              "remainingData": "<0>{{value}}</0> von <0>{{initial}} MB</0> verfügbar",
              "remainingDataGB": "<0>{{value}}</0> von <0>{{initial}} GB</0> verfügbar",
              "remainingMin": "<0>{{value}}</0> von <0>{{initial}} Min.</0> verfügbar",
              "runtimeUsage": "<0>{{value}}</0> von <0>{{initial}} Tage</0> übrig",
              "unlimitedCalls": "Unlimitierte Internationale Anrufe"
            },
            "flatMobileHint": {
              "notIncluded": "Nicht inkludiert",
              "renewalReminder": "Das Roaming-Datenvolumen erneuert sich am Ersten des Monats.",
              "text": "Weil sich dein inkl. Roaming-Datenvolumen immer auf den 1. des Monats erneuert, bekommst du dein Roaming im ersten Monat anteilig zur Verfügung gestellt.",
              "title": "Anteiliges Roaming-Datenvolumen im ersten Monat"
            },
            "flatMobileTooltip": {
              "example": {
                "description": "Aktivierung am 15. Januar: Du erhältst 50% des Roaming-Datenvolumen für Januar und 100% ab Februar.",
                "title": "Beispiel"
              },
              "monthlyRenewal": {
                "description": "Dein Roaming-Datenvolumen wird jeden Monat am 1. erneuert, unabhängig vom Aktivierungsdatum des Abos.",
                "title": "Monatlicher Neubeginn"
              },
              "proRataVolume": {
                "description": "In deinem ersten Monat erhältst du dein Roaming-Datenvolumen anteilig zur Verfügung gestellt.",
                "title": "Anteiliges Roaming-Datenvolumen im ersten Monat"
              },
              "title": "Infos zum Inklusivvolumen"
            },
            "inactive": {
              "hint": "Jedes Roaming Paket ist 365 Tage gültig und wird erst aktiviert, wenn du im Ausland bist.<br><br>Wenn dein Abo Telefonie und SMS beinhaltet, aktivierst du Telefonie und SMS im Ausland unter <0>Anrufe</0>."
            },
            "ordered": {
              "usage": "Deine Roamingoption ist in Vorbereitung."
            },
            "ready": {
              "daysLeft": "Noch <0>{{days}}</0> von <0>{{initial}} Tagen</0> zum Aktivieren",
              "daysLeftWithoutTotal": "Noch <0>{{days}} Tage</0> zum Aktivieren",
              "firstPackageOfUsageZone": {
                "subtitle": "Beginnt sobald du im Ausland bist."
              },
              "notFirstPackageOfUsageZone": {
                "subtitle": "Beginnt nach Verbrauch vorheriger Pakete der Zone."
              }
            }
          }
        },
        "subscription": {
          "chooseSubscription": "Abo wählen",
          "noSubscription": "Kein Abo aktiv",
          "options": {
            "changeDisabled": "Die Abo-Optionen können erst nach Abschluss geändert werden.",
            "changeDisabledMissingPaymentMean": "Dein Abo kann erst nach hinzufügen von Zahlungsmitteln geändert werden.",
            "changeDisabledPauseReview": "Die Abo-Optionen können erst geändert werden, nachdem du diese Pausierung bestätigt oder abgebrochen hast.",
            "changeDisabledWatchSim": "Die Abo-Optionen können erst geändert werden, wenn die Watch SIM aktiviert ist.",
            "dataRoaming": "Daten-Roaming EU/USA",
            "download": "Download",
            "upload": "Upload"
          },
          "price": {
            "title": "Abo Grundpreis"
          },
          "status": {
            "billingPeriod": {
              "change": "Wechseln",
              "label": "Rechnungsperiode"
            },
            "cancelPause": "Pausierung abbrechen",
            "changeDisabled": "Der Abo-Status kann erst nach Abschluss geändert werden.",
            "changeDisabledFlatHome": "Ab dem {{date}} kannst du den Abo-Status deines Flat-Home-Abos verwalten. Flat Home hat eine Mindestvertragslaufzeit von 12 Monaten.",
            "changeDisabledWatchSim": "Das Abo kann erst pausiert werden, wenn die Watch SIM aktiviert ist.",
            "inPreparation": "Abo wird vorbereitet",
            "locked": "Dein Abo ist gesperrt",
            "pause": "Abo pausieren",
            "pausing": "Wird pausiert am <0>{{date}}</0>",
            "paymentFailed": {
              "text": "Dein Abo läuft weiter sobald du <0>dein Zahlungsmittel</0> aktualisiert hast.",
              "title": "Zahlung fehlgeschlagen"
            },
            "title": "Abo-Status"
          },
          "successor": "Wechselt auf {{flatName}}",
          "successorOn": "Wechselt am <0>{{date}}</0> auf {{flatName}}",
          "title": "Dein Abo"
        },
        "tabs": {
          "abo": "Abo",
          "details": "Details",
          "disabledHint": {
            "inactive": "Du kannst diesen Tab nicht öffnen, da du ein aktives Abo benötigst.",
            "lockRequested": "Du kannst diesen Tab öffnen, sobald dein Abo nicht mehr gesperrt ist.",
            "numberPorting": "Dein Abo kann verwaltet werden, sobald die Rufnummernportierung abgeschlossen ist.",
            "servicePending": "Du kannst diesen Tab öffnen, sobald dein Abo vorbereitet ist."
          },
          "numberPorting": {
            "keepNumberQuestion": "Möchtest du deine bisherige Rufnummer behalten und die Portierung hiermit beantragen?",
            "title": "Nummernportierung",
            "warning": "Diese Option kannst du <0>nicht</0> zu einem späteren Zeitpunkt nachholen."
          },
          "roaming": "Roaming",
          "voice": "Anrufe"
        },
        "tariff": {
          "autoRenew": "Abo pausieren",
          "changeDisabledReasons": {
            "flatHome": {
              "hint": "(Flat Home hat eine Mindestvertragslaufzeit von 12 Monaten)",
              "text": "Ab dem <strong>{{date}}</strong> kannst du dein Flat Home Abo pausieren.",
              "title": "Info zum Pausieren"
            }
          },
          "checkout": {
            "aliasNotSaved": "Dein Abo wurde geändert, der Aboname „{{alias}}“ konnte aber nicht gespeichert werden. Du kannst ihn unter Details erneut ändern.",
            "aliasSaveFailed": "Der Aboname konnte nicht gespeichert werden. Bitte versuche es erneut.",
            "creditText": "(Restlaufzeit)",
            "creditTextOthers": "(Sonstiges)",
            "noProductId": "Bitte navigiere zurück und wähle ein Produkt aus.",
            "tariffActivation": {
              "asSuccessor_one": "Nach Ablauf der <strong>Restzeit von einem Tag</strong> wird dieses Abo automatisch aktiviert:",
              "asSuccessor_other": "Nach Ablauf der <strong>Restzeit von {{count}} Tagen</strong> wird dieses Abo automatisch aktiviert:",
              "now_one": "Die Restlaufzeit von einem Tag wird dir gutgeschrieben. Mit der Bestätigung wird dein Zahlungsmittel belastet und das Abo <strong>sofort</strong> aktiviert:",
              "now_other": "Die Restlaufzeit von {{count}} Tagen wird dir gutgeschrieben. Mit der Bestätigung wird dein Zahlungsmittel belastet und das Abo <strong>sofort</strong> aktiviert:",
              "now_zero": "Mit der Bestätigung wird dein Zahlungsmittel belastet und das Abo <strong>sofort</strong> aktiviert:"
            },
            "watchSimDeactivationHint": "Wenn du auf ein reines Daten-Abo wechselst, wird <0>deine Watch SIM deaktiviert</0>. Die Watch SIM ist nur mit einem Abo mit Telefonie und SMS verfügbar.",
            "watchSimWarning": "Warnung"
          },
          "goodToKnow": {
            "inactiveHint": "Du kannst dein Abo innerhalb von 12 Monaten zu jedem Zeitpunkt wieder aktivieren.",
            "missingPaymentMeanHint": "Dein Paket läuft weiter, sobald du ein <0>Zahlungsmittel</0> hinzufügst.",
            "numberPorting": "Dein Abo wird aktiviert, sobald die Rufnummernportierung abgeschlossen ist.",
            "warning": "Achtung"
          },
          "once": "einmalig",
          "payInterval": "alle {{days}} Tage",
          "serviceIsPendingHint": "Dein Abo wird aktiviert. Dieser Vorgang kann bis zu 15 Minuten dauern. Solltest du längere Wartezeiten feststellen, kontaktiere den Support.",
          "until": "bis zum",
          "untilRevoke": "bis zum Widerruf",
          "yourTariff": "Dein Abo"
        },
        "voiceSettings": {
          "errors": {
            "changeInProgress": "Eine Änderung der Anrufe ist bereits in Bearbeitung. Bitte versuche es später erneut."
          },
          "reasons": {
            "askSupport": "Bei Fragen kannst du dich gerne an unseren Support wenden.",
            "costLimitReached": "Kostenlimit ist überschritten.",
            "creditClassC": "Diese Funktionen sind nicht verfügbar, wenn du kein in der Schweiz ausgestelltes Ausweisdokument hochgeladen hast oder nicht in der Schweiz wohnst.",
            "noActiveVoicePackage": "Diese Funktion steht bei reinen Daten-Abos nicht zur Verfügung.",
            "noPaymentMean": "Du hast kein Zahlungsmittel hinterlegt.",
            "servicePendingBlocked": "Die Anrufe-Einstellungen können nicht geändert werden, solange ein Auftrag für diese SIM noch bearbeitet wird.",
            "voiceSettingsBlocked": "Einige Anrufe-Einstellungen sind aus folgendem Grund gesperrt:"
          },
          "settings": {
            "adult": {
              "subtitle": "Kostenpflichtige Mehrwertdienst Nachrichten im Bereich Erwachsenenunterhaltung",
              "title": "Erwachsenenunterhaltung"
            },
            "roaming": {
              "subtitle": "Anrufe ins Ausland sowie aus der Schweiz ins Ausland sind kostenpflichtig gemäss <0>Tarifliste</0>.",
              "title": "Roaming und internationale Anrufe"
            },
            "serviceNumbers": {
              "subtitle": "Kostenpflichtige Anrufe auf 0906- und 090x-Nummern",
              "title": "Mehrwertdienst Nummer"
            },
            "serviceSMS": {
              "subtitle": "Kostenpflichtige Mehrwertdienst Nachrichten",
              "title": "Mehrwertdienst SMS"
            },
            "voiceBox": {
              "subtitle": "Verpasste Anrufe werden auf die Sprachbox umgeleitet. Wenn du dich im Ausland befindest, können dadurch Kosten entstehen.",
              "title": "Sprachbox"
            }
          }
        },
        "watchSim": {
          "autoRenewal": {
            "disable": {
              "description_one": "Nach Ablauf der <strong>Restzeit von ein Tag</strong> wird dieses Abo pausiert:",
              "description_other": "Nach Ablauf der <strong>Restzeit von {{count}} Tagen</strong> wird dieses Abo nicht mehr automatisch erneuert:",
              "goodToKnowText": "Du kannst es zu jedem Zeitpunkt wieder aktivieren.",
              "successMessage": "Das Abo wird pausiert."
            },
            "enable": {
              "description": "Das folgende Abo läuft <strong>alle {{count}} Tage</strong> weiter:",
              "goodToKnowText": {
                "withMainSimAR": "Bitte beachte, dass Watch SIM nur mit einem aktiven Haupt-Abo funktioniert. Ist dein Haupt-Abo pausiert, wird es dadurch ebenfalls fortgesetzt."
              },
              "nextBillDescription": "Deine Watch SIM wird ab dem nächsten Rechnungsmonat berechnet. Heute zahlst du nichts.",
              "title": "Watch SIM reaktivieren"
            }
          },
          "checkout": {
            "autoRenewal": {
              "hint_one": "Die <0>verbleibende Zeit von einem Tag</0> wird dir gutgeschrieben. Nach der Bestätigung wird deine Zahlungsmethode belastet und das Paket wird sofort aktiviert:",
              "hint_other": "Die <0>verbleibende Zeit von {{count}} Tage</0> wird dir gutgeschrieben. Nach der Bestätigung wird deine Zahlungsmethode belastet und das Paket wird sofort aktiviert:",
              "message": "Dein Abo bleibt aktiv. Du kannst deine Einstellungen jederzeit verwalten."
            },
            "confirm": "Buchung bestätigen",
            "creditRemainingTime": "Guthaben (Restlaufzeit)",
            "title": "Watch hinzufügen",
            "today": "Heute"
          },
          "display": {
            "autoRenew": "Watch SIM pausieren",
            "creationHelpText": "Mit dieser Option kannst du deine Smartwatch mit deinem Smartphone verbinden. Bitte vergewissere dich vor der Buchung, dass deine Geräte verbunden werden können.",
            "linkHelpText": "Um deine Smartwatch mit deinem Smartphone zu verbinden, folge bitte den Anweisungen auf deiner Smartwatch oder <0>unserer Anleitung</0>.",
            "linkHelpUrl": "https://support.digitalrepublic.ch/de/support/solutions/folders/33000217141",
            "noActiveOption": "Keine Watch SIM aktiv",
            "pending": "Deine Watch SIM kann in Kürze aktiviert werden.",
            "title": "Deine Watch SIM",
            "voiceOption": "Voice Option",
            "voiceOptionNeeded": "Die Watch SIM kann nur mit einem aktiven Flat Mobile-Abo gebucht werden."
          },
          "status": {
            "activating": "Wird vorbereitet",
            "cancelPause": "Pausierung abbrechen",
            "changeDisabled": "Der Watch SIM-Status kann erst nach Abschluss geändert werden.",
            "locked": "Deine Watch SIM ist gesperrt",
            "pause": "Watch SIM pausieren",
            "pausing": "am <0>{{date}}</0>",
            "title": "Watch SIM-Status"
          }
        }
      },
      "purchaseIntent": {
        "esim": {
          "button": "eSIM aktivieren",
          "message": "Aktiviere deine eSIM ohne Wartezeit und nutze dein Abo."
        },
        "physical": {
          "button": "SIM-Karte aktivieren",
          "defaultAlias": "SIM-Karte",
          "message": "Sobald deine SIM-Karte angekommen ist kannst du sie hier aktivieren."
        },
        "status": {
          "onTheWay": "SIM-Karte unterwegs"
        }
      },
      "sections": {
        "toActivate": "Zu aktivieren"
      }
    },
    "common": {
      "alerts": {
        "agentLogin": "Login als Agent",
        "error": "Die Aktion ist fehlgeschlagen.",
        "tryAgain": "Erneut versuchen"
      },
      "autoRenewal": {
        "dueDate": "Rechnung fällig am {{date}}",
        "goodToKnow": "Du kannst dein Abo jederzeit pausieren oder kündigen.",
        "nextBillTitle": "Deine nächste Rechnung:",
        "successMessage": "Dein Abo läuft wieder."
      },
      "bills": "Rechnungen",
      "buttons": {
        "abort": "abbrechen",
        "bookOption": "Paket buchen",
        "cancel": "abbrechen",
        "change": "ändern",
        "clearSearch": "Suche löschen",
        "close": "schliessen",
        "confirm": "bestätigen",
        "continue": "weiter",
        "disable": "ausschalten",
        "enable": "einschalten",
        "save": "speichern",
        "showOptions": "Optionen anzeigen",
        "skipForLater": "Später erledigen",
        "submit": "absenden",
        "switch": "wechseln"
      },
      "checkout": {
        "creditOther": "Guthaben (Sonstiges)",
        "nowToPay": "Jetzt zu bezahlen",
        "paymentMethod": "Zahlungsmittel",
        "paymentMethodHint": "Wenn du ein anderes Zahlungsmittel auswählen möchtest, ändere dies bitte in den <0>Einstellungen</0> deiner Benutzerkontoverwaltung.",
        "paymentMethodSubtitle": "Bereits hinterlegte Zahlungsmittel",
        "sum": "Summe"
      },
      "device": {
        "attributes": {
          "deviceType": "Gerätetyp",
          "followupPackage": "Folgeabo",
          "iccid": "ICCID",
          "mobileSubscription": "Mobile Abo",
          "openRuntime": "Laufzeit",
          "pin": "PIN",
          "puk": "PUK",
          "roamingDataConsumption": "Roaming Datenverbrauch",
          "roamingOpenRuntime": "Roaming Laufzeit",
          "roamingStatus": "Roaming Status",
          "simNumber": "SIM-Nummer",
          "simType": "SIM-Typ",
          "status": "Status",
          "tariff": "Abo",
          "telephoneNumber": "Handynummer",
          "voiceOption": "Voice Option"
        },
        "placeholder": {
          "alias": "Mein Abo"
        }
      },
      "esim": {
        "install": "eSIM installieren",
        "installHint": "Tippe auf den Button um deine eSIM zu installieren.",
        "profile": "eSIM Profil"
      },
      "listOfData": {
        "error": "Beim Laden ist ein Fehler aufgetreten.",
        "noMoreData": "Alle SIM Karten wurden geladen."
      },
      "nextBill": "Nächste Rechnung am <0>{{date}}</0>",
      "openBillReason": "Du hast mindestens eine offene Rechnung.",
      "or": "oder",
      "phoneNumber": "Rufnummer",
      "roaming": {
        "countryList": "Länderliste",
        "dialog": {
          "title": "Roaming Daten Zonen und Länder"
        },
        "zones": {
          "ZONE1": "EU/USA",
          "ZONE2": "Zone 2",
          "ZONE3": "Zone 3",
          "ZONE4": "In allen übrigen Ländern werden keine Roamingleistungen angeboten.",
          "countries": {
            "ZONE1": "Andorra, Belgien, Bulgarien, Dänemark, Deutschland, Estland, Färöer, Finnland, Frankreich, Gibraltar, Griechenland, Grönland, Guernsey, Irland, Island, Isle of Man, Italien, Jersey, Kanada, Kroatien, Lettland, Liechtenstein, Litauen, Luxemburg, Malta, Monaco, Niederlande, Norwegen, Österreich, Polen, Portugal, Puerto Rico, Rumänien, San Marino, Schweden, Slowakei, Slowenien, Spanien, Tschechien, Türkei, Ungarn, USA, Vatikan, Vereinigtes Königreich, Zypern.",
            "ZONE2": "Albanien, Algerien, Australien, Bosnien-Herzegowina, Brasilien, Dominikanische Republik, Israel, Kosovo, Marokko, Mazedonien, Mexiko, Montenegro, Oman, Palästina, Qatar, Serbien, Singapur, Südafrika, Thailand, Vereinte Arabische Emirate, Ägypten.",
            "ZONE3": "Afghanistan, Amerikanische Jungferninseln, Anguilla, Antigua und Barbuda, Argentinien, Armenien, Aserbaidschan, Bahamas, Bangladesch, Barbados, Benin, Bermuda, Botswana, Brunei Darussalam, Burkina Faso, Chile, China, Costa Rica, Dominica, Ecuador, El Salvador, Elfenbeinküste, Fidschi, Französisch-Guayana, Französisch-Polynesien, Französische Antillen, Georgien, Grenada, Guadeloupe, Guatemala, Guinea, Guinea-Bissau, Guyana, Haiti, Honduras, Hongkong, Indien, Indonesien, Irak, Iran, Jamaika, Japan, Kaimaninseln, Kambodscha, Kamerun, Kap Verde, Kenia, Kirgisistan, Kolumbien, Kongo (Brazzaville), Kongo (Kinshasa), Kuba, Kuwait, Laos, Liberia, Madagaskar, Malawi, Malaysia, Mali, Martinique, Mauritius, Moldawien, Mosambik, Nepal, Neuseeland, Nicaragua, Niederländische Antillen, Niger, Nigeria, Pakistan, Panama, Paraguay, Peru, Philippinen, Ruanda, Russland, Réunion, Saint-Barthélemy, Saint-Martin (franz. Teil), Sambia, Senegal, Seychellen, Sierra Leone, Sri Lanka, St. Kitts and Nevis, St. Lucia, St. Vincent und die Grenadinen, Sudan, Südkorea, Südsudan, Taiwan, Trinidad und Tobago, Tschad, Tunesien, Turks- und Caicosinseln, Uganda, Ukraine, Uruguay, Usbekistan, Vietnam, Weißrussland."
          }
        }
      },
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "notAvailable": "Nicht verfügbar",
        "suspended": "Gesperrt"
      },
      "stepLabels": {
        "rateSelection": "Abo Auswahl"
      },
      "stepMenuLabel": "Zu einem anderen Schritt springen",
      "subscriptionCount_one": "{{count}} Abo",
      "subscriptionCount_other": "{{count}} Abos",
      "tooltip": {
        "actionNotPossible": {
          "text_one": "Du kannst diese Funktion aus folgendem Grund nicht nutzen:",
          "text_other": "Du kannst diese Funktion aus folgenden Gründen nicht nutzen:",
          "title": "Aktuell nicht möglich"
        },
        "moreInfo": "Weitere Informationen"
      }
    },
    "documents": {
      "tabItemizedBill": {
        "additionalSelectedNumbers_one": "und {{count}} weitere Rufnummer ausgewählt",
        "additionalSelectedNumbers_other": "und {{count}} weitere Rufnummern ausgewählt",
        "btnSearch": "Suchen",
        "choosePlanAndPeriod": "Wähle eine Rufnummer und einen Zeitraum aus, um deine Verbindungsübersicht einzusehen.",
        "headline": "Deine Verbindungsnachweise",
        "noItemizedBillOverview": "Es gibt noch keine Verbindungsübersicht der letzten 6 Monate.",
        "onlyOneFilterAllowed": "Nur ein Filter erlaubt",
        "placeholderPeriods": "Wähle den Zeitraum",
        "placeholderPlans": "Wähle die Rufnummer",
        "placeholderSearchTerm": "Rufnummer suchen",
        "resultsHeadline": "Suchergebnis",
        "subtitle": "Du möchtest eine Übersicht über deine getätigten Telefonate und SMS? Lade dir die Verbindungsnachweise der letzten 6 Monate als PDF herunter.",
        "title": "Verbindungsübersicht",
        "zipName": "Einzelverbindungsnachweise - Digital Republic"
      }
    },
    "flatHome": {
      "duration": "12 Monate Laufzeit"
    },
    "friendsWithBenefits": {
      "creatingGroup": "Gruppe wird erstellt...",
      "error": {
        "fail": "Fehler beim Erstellen der Gruppe"
      },
      "groupName": "Neue Freundesgruppe",
      "groupOverview": {
        "confirmLeave": "Verlassen",
        "discount": "Rabatt",
        "eligibleProducts": "Abos",
        "groupTitle": "{{name}}'s Friends with Benefits",
        "groupTitleSEnding": "{{name}}' Friends with Benefits",
        "howItWorks": "So funktioniert’s",
        "howItWorksModal": {
          "changingSubscriptionAnswer": "Der Rabatt wird bei der Zahlung abgezogen. Wenn du zum Beispiel ein neues Abonnement buchst oder die automatische Verlängerung aktiv ist, gilt der zu diesem Zeitpunkt gültige Rabatt. Wenn du ein neues Abonnement hinzufügst, wird es sofort für die Berechnung deines Rabattes berücksichtigt, sodass du sofort von einem noch besseren Angebot profitierst.",
          "changingSubscriptionQuestion": "Wie funktioniert der Rabatt, wenn ich Änderungen an meinen Abonnements vornehme?",
          "eligibleSubscriptionsAnswer": "Jedes Flat Mobile Handy Abo von Digital Republic wird deinem Rabatt angerechnet. Das heisst auch, dass du selbst einen Rabatt erhältst, wenn du mehr als ein Flat Mobile auf deinem Konto aktiv hast.\n\nBeachte, dass Abos nur dann an den Rabatt angerechnet werden, wenn auf dem entsprechenden Kundenkonto ein gültiges Zahlungsmittel hinterlegt ist.",
          "eligibleSubscriptionsQuestion": "Welche Abos werden an den Rabatt angerechnet?",
          "flatMobileInactiveAnswer": "Wenn du noch kein aktives Flat Mobile hast, kannst du trotzdem in einer Friends with Benefits Gruppe sein.\n\nNach 30 Tagen ohne bezahltes Abo wirst du allerdings automatisch aus der Gruppe entfernt, damit der Platz frei wird.",
          "flatMobileInactiveQuestion": "Was passiert, wenn ich noch kein aktives Flat Mobile habe?",
          "joinMoreGroupsAnswer": "Nein, du kannst immer nur einer Gruppe angehören. Wenn du einer anderen Gruppe beitreten möchtest, musst du zuerst deine aktuelle Gruppe verlassen.",
          "joinMoreGroupsQuestion": "Kann ich mehr als einer Gruppe beitreten?",
          "maxMemberLimitExceededAnswer": "Jede Gruppe kann bis zu 15 Mitglieder haben. Wenn deine Gruppe voll ist, können keine weiteren Mitglieder beitreten. Der Einladungslink informiert neue Nutzer darüber, dass die Gruppe ihre maximale Mitgliederzahl erreicht hat, sodass du dies nicht manuell verwalten musst.",
          "maxMemberLimitExceededQuestion": "Was passiert, wenn meine Gruppe die maximale Mitgliederzahl erreicht hat?",
          "numberPortingInProgressAnswer": "Kein Problem: Wenn deine Nummer noch auf dem Weg zu Digital Republic ist, kannst du in der Gruppe bleiben, bis die Portierung abgeschlossen ist.\n\nBeachte, dass dein Abo erst zum Rabatt gerechnet wird, wenn die Portierung abgeschlossen ist und dein Abo aktiv wird.",
          "numberPortingInProgressQuestion": "Was, wenn meine Nummer noch portiert wird?"
        },
        "inactiveWarning": "<0>Hinweis</0><br />Keine aktiven Abonnements. Dieses Mitglied wird automatisch in {{days}} Tagen entfernt, wenn keine geeigneten Produkte hinzugefügt werden.",
        "inviteFriends": "Freunde einladen",
        "leaveTribe": "Gruppe verlassen",
        "leaveTribeConfirmationText": "Wenn du diese Gruppe verlässt, erhältst du keinen Gruppenrabatt mehr. Du kannst jedoch jederzeit eine neue Gruppe erstellen oder einer anderen Gruppe beitreten.",
        "leaveTribeConfirmationTitle": "Gruppe verlassen?",
        "linkCopied": "Link kopiert",
        "linkCopyError": "Link konnte nicht kopiert werden",
        "members": "{{count}} Mitglied",
        "members_other": "{{count}} Mitglieder",
        "newFriend": "Neuer Freund",
        "onpHint": "Abo wird erst nach erfolgter Rufnummernportierung dem Rabatt angerechnet.",
        "orderFM": "Flat Mobile bestellen",
        "share": "Einladung teilen",
        "sharePanel": {
          "email": "E-Mail",
          "subtitle": "Teilen über...",
          "title": "Teile den Code und lade deine Freunde ein"
        },
        "shareSubHeadline": "Willst du mit mir sparen? <br />( ) Ja ( ) Nein ( ) Vielleicht",
        "shareText": "Bei Digital Republic sparen wir bis zu 30% auf unlimitierte Handy Abos ab CHF 13.-.",
        "shareTitle": "Tritt Friends with Benefits bei | Digital Republic",
        "status": {
          "discountTitle": "Du profitierst von <0>{{percentage}} Rabatt</0>.",
          "fullDescription": "Gut gemacht, du hast so viele Friends with Benefits, dass du das <0>Gruppenlimit erreicht</0> hast.",
          "fullMaxDescription": "Gut gemacht, du hast so viele Friends with Benefits, dass du das <0>Limit erreicht</0> hast.",
          "fullMaxTitle": "Deine Gruppe ist voll, du profitierst von <0>{{percentage}} Rabatt</0>.",
          "fullTitle": "Deine Gruppe ist voll und du profitierst von <0>{{percentage}} Rabatt</0>.",
          "maxDiscount": "Damit habt ihr den <0>maximalen Rabatt</0> erreicht.",
          "nextLevel_one": "Füge <0>{{count}} weiteres Mitglied</0> oder Gerät hinzu, um die nächste Stufe von <1>{{nextPercentage}} Rabatt</1> zu erreichen.",
          "nextLevel_other": "Füge <0>{{count}} weitere Mitglieder</0> oder Geräte hinzu, um die nächste Stufe von <1>{{nextPercentage}} Rabatt</1> zu erreichen."
        },
        "subheading": "Egal was euch verbindet, hauptsache ihr spart.",
        "tableTitle": "Deine Freunde"
      },
      "joinGroup": {
        "error": {
          "alreadyInGroup": "Du bist bereits Friends with Benefits mit anderen. Bleib ihnen treu oder verlasse die Gruppe, bevor du einer neuen beitrittst.",
          "deletedGroup": "Diese Friends with Benefits haben sich in Luft aufgelöst. Gründe eine neue Gruppe oder tritt einer bestehenden bei.",
          "notFound": "Diese Friends with Benefits konnten nicht gefunden werden. Vielleicht ein Tippfehler im Link?",
          "paymentMethod": "Dieses Zahlungsmittel wird leider nicht unterstützt.",
          "tribeFull": "Hier ist kein Platz mehr. Du kannst aber jederzeit eine neue Friends with Benefits Gruppe starten."
        },
        "sucess": "Du bist beigetreten"
      },
      "newGroup": {
        "createButton": "Gruppe erstellen",
        "footer": "Kennst du bereits jemanden mit einer Gruppe? Frag nach dem Einladungslink und leg los.",
        "notificationDescription": "Mit jedem weiteren Flat Mobile Abo in deiner Gruppe, erhöht sich der Rabatt. Spare bis zu 30% bei deinem Mobile Abo.",
        "notificationTitle": "Erhalte bis zu <0>30% Rabatt</0>.",
        "steps": {
          "1": "Richte deine Gruppe mit einem einzigen Klick ein.",
          "2": "Versende, poste oder teile deinen Einladungslink, wie und wo immer du möchtest.",
          "3": "Jeder kann mitmachen <0>und</0> andere einladen"
        },
        "subtitle": "{{name}}, sichere dir und deinen Freunden einen Rabatt",
        "title": "Neue Gruppe"
      },
      "welcome": {
        "benefits": {
          "instant": {
            "text": "Aktivierte Abos profitieren sofort von jeder neu erreichten Rabattstufe.",
            "title": "Sofort profitieren"
          },
          "saving": {
            "text": "Je größer die Gruppe, desto höher der Rabatt – bis 30% sind möglich.",
            "title": "Gemeinsam sparen"
          },
          "viral": {
            "text": "Jedes Mitglied kann weitere einladen – egal wo ihr den Link postet.",
            "title": "Viral gehen"
          }
        },
        "discountShort": "Dein Rabatt: {{discount}}%",
        "flatMobileOne": "Flat Mobile One",
        "flatMobileThree": "Flat Mobile Three",
        "flatMobileTwo": "Flat Mobile Two",
        "greeting": "Willkommen",
        "joinNow": "Jetzt beitreten",
        "link": "https://digitalrepublic.ch/de/fwb-kundeninformation/",
        "nextSteps": "So sicherst du dir deinen Benefit",
        "notConvinced": "Du hast weitere Fragen? <0>Lerne mehr über Friends with Benefits und unsere Pläne</0>",
        "priceHint": "Das Flatrate-Abo für die Schweiz gibt’s schon ab CHF {{price}} pro Monat. Je mehr Abos zur Gruppe gehören, desto mehr Rabatt erhalten alle.",
        "rates": "Unsere Abos",
        "referralCTA": "Damit profitierst du von Handy-Abos ohne Aktivierungsgebühr und ohne Mindestlaufzeit. Mit Digital Republic ganz ohne Commitment.",
        "slides": {
          "aboutMe": "Über mich",
          "counter": "{{step}} / {{total}}",
          "goToSlide": "Zu Slide {{step}} springen",
          "lastSlide": {
            "cta": "Ich bin dabei",
            "headline": "Jetzt bist du dran: mach den nächsten Schritt.",
            "notification": {
              "description": "Bis zu 30% Rabatt für alle.",
              "title": "Mehr Friends with Benefits"
            },
            "steps": {
              "invite": "Lade weitere Freunde ein",
              "save": "Lass den Preis für dich und die anderen noch weiter purzeln."
            },
            "title": "Jetzt bist du dran"
          },
          "pauseSlides": "Pause",
          "resumeSlides": "Fortsetzen",
          "searchingFor": "Auf der Suche nach:",
          "selectSlide": "Slide auswählen",
          "slide1": {
            "bullet1": "Flexible Handy Abos ohne versteckte Kosten",
            "bullet2": "Alles unlimitiert in der Schweiz",
            "description": "Ich bin Digital Republic – fair, einfach und flexibel. Kein Commitment, keine versteckten Kosten – bei mir weisst du immer, woran du bist. Ich passe zu dir, wenn du Freiheit liebst und dich nicht binden willst.",
            "match": "Kundinnen und Kunden, die Freiheit, Fairness und Fortschrittlichkeit lieben."
          },
          "slide2": {
            "bullet1": "Alles unlimitiert in der CH inkl. 5G",
            "bullet2": "3 GB Roaming Daten in der Zone EU/USA",
            "bullet3": "30 Min Roaming-Telefonie in der Zone EU/USA",
            "description": "Ich bin das bodenständige Abo. Ein bisschen Roaming, kein Schnickschnack – nur das, was du wirklich brauchst. Ich passe zu dir, wenn dir die Schweiz vollkommen reicht, mit einem kleinen Kontingent für Reisen ins Ausland.",
            "match": "Sparsamen und Minimalisten",
            "title": "Flat Mobile One | CHF 13.–"
          },
          "slide3": {
            "bullet1": "Alles unlimitiert in der CH inkl. 5G",
            "bullet2": "20 GB Roaming Daten in der Zone EU/USA",
            "bullet3": "100 Min Roaming-Telefonie in der Zone EU/USA",
            "description": "Ich bin so spontan wie dein Alltag, der dich auch mal über die Schweiz hinaus trägt. Ich bin dein Abo, wenn du High-Speed liebst, dich nicht binden willst, aber doch mal kurz über die Landesgrenze schauen (surfen oder telefonieren) möchtest.",
            "match": "Spontanen und Unkomplizierten",
            "title": "Flat Mobile Two | CHF 18.–"
          },
          "slide4": {
            "bullet2": "50 GB Roaming Daten in der Zone EU/USA",
            "bullet3": "Unlimitierte Roaming-Telefonie in der Zone EU/USA",
            "description": "Ich bin für die, die mehr wollen - ohne Grenze nach oben. Einfach loslegen ohne zu überlegen. Mit mir hast du unlimitierten High-Speed in der Schweiz und surfst und telefonierst über die Landesgrenzen hinaus. Ich bin DAS Abo ohne jegliche Kompromisse.",
            "match": "Freien und Kompromisslosen",
            "title": "Flat Mobile Three | CHF 25.–"
          },
          "slide5": {
            "bullet1": "Lässt dich deine Handy-Nummer behalten",
            "bullet2": "Kündigt für dich bei deinem alten Anbieter.",
            "description": "Trennungen sind nie einfach. Deshalb helfe ich dir, über deine Beziehung mit deinem alten Anbieter hinwegzukommen. Alles, was ich dazu brauche ist deine Nummer und den Namen von deinem Ex(-Anbieter) 😉",
            "match": "Dem einfachen Break-Up",
            "title": "Nummernportierung"
          }
        },
        "steps": {
          "benefit": "Profitiere von bis zu 30% Rabatt",
          "order": "Wähle dein Flat Mobile Handy Abo",
          "register": "Tritt Friends with Benefits bei"
        },
        "stories": "Lerne Digital Republic kennen",
        "textFlatMobileOne": "CH unlimitiert, 3 GB & 30 Min. Roaming",
        "textFlatMobileThree": "CH unlimitiert, 50 GB & unlimitiert Min. Roaming",
        "textFlatMobileTwo": "CH unlimitiert, 20 GB & 100 Min. Roaming",
        "unknown": "jemand",
        "youWereInvited": "Du wurdest von <0>{{user}}</0> zu Friends with Benefits eingeladen."
      }
    },
    "layout": {
      "header": {
        "menu": {
          "logout": "Abmelden"
        }
      },
      "menu": {
        "bottomNav": {
          "ariaLabel": "Untere Navigation"
        },
        "burger": {
          "close": "Navigation schliessen",
          "open": "Navigation öffnen"
        },
        "items": {
          "account": "Konto",
          "accountAriaLabel": "Konto",
          "cockpit": "Cockpit",
          "documentsAriaLabel": "Rechnungen und Dokumente",
          "friendsWithBenefitsShort": "FwB",
          "mySubscriptions": "Abos"
        },
        "sidebar": {
          "ariaLabel": "Hauptnavigation",
          "collapse": "Navigation einklappen",
          "expand": "Navigation ausklappen"
        }
      },
      "skipToContent": "Zum Inhalt springen",
      "table": {
        "pageNumberComboBox": {
          "entriesPerPage": "Zeilen pro Seite"
        },
        "pagination": {
          "ariaLabel": "Seitennavigation"
        },
        "sortBy": "Sortiere nach {{title}}"
      },
      "tiles": {
        "activeSim": {
          "internationalCalls": "Anrufe EU/USA",
          "notAvailable": "nicht verfügbar",
          "roamingCallUsage": "{{remaining}} / {{available}} Min verfügbar",
          "roamingUsage": "{{remaining}} / {{available}} MB verfügbar",
          "roamingUsageGB": "{{remaining}} / {{available}} GB verfügbar"
        },
        "addDevice": {
          "button": "Jetzt Abo hinzufügen",
          "title": "Füge ein neues Abo hinzu"
        },
        "complete": "Ergänzen",
        "evnCard": {
          "button": "Jetzt anzeigen",
          "text": "Verstehe deine Rechnungen mit einer detaillierten Übersicht deiner Anrufe und SMS besser.",
          "title": "Übersicht"
        },
        "inactive": {
          "activateSubscriptionButton": "Abo aktivieren",
          "activateSubscriptionText": "Wähle unter „Abo aktivieren“ ein neues Abo für dieses Gerät aus.",
          "activateText": "Wähle unter <0>Abo verwalten</0> ein neues Abo für dieses Gerät aus.",
          "beginsAfterID": "Beginnt nach dem ID-Check",
          "noPackageActive": "Kein Datenpaket aktiv",
          "noSubscriptionActive": "kein Abo aktiviert"
        },
        "numberPorting": {
          "numberBeingTransferred": "Nummer wird übernommen",
          "sections": {
            "dateBeingIdentified": "Portierungsdatum wird festgelegt",
            "done": "Portierung ist abgeschlossen",
            "known": "Portierung erfolgt am {{val}}",
            "missingInformation": "Es fehlen Informationen",
            "requested": "Portierung wurde beantragt",
            "simActivationPending": "SIM-Aktivierung ausstehend"
          }
        },
        "pending": {
          "chipLabel": "In Vorbereitung",
          "couldNotRenewTitle": "Konnte nicht fortgesetzt werden.",
          "inProcess": "Dein Abo wird vorbereitet",
          "missingPaymentMethod": "Dein Paket konnte nicht fortgesetzt werden, da kein Zahlungsmittel hinterlegt ist."
        },
        "promoItemizedBill": {
          "activateNow": "Jetzt ansehen",
          "heading": "Verbindungsübersicht",
          "text": "Verstehe deine Rechnungen besser mit der Verbindungsübersicht zu Anrufen und SMS."
        },
        "qrCodeTile": {
          "activateText": "Scanne diesen QR-Code mit deinem Smartphone, um deine eSIM zu installieren.",
          "inProcessText": "Dein eSIM Profil wird generiert. Das dauert einige Minuten.",
          "instructionsLink": "https://support.digitalrepublic.ch/de/support/solutions/articles/33000277288-wie-aktiviere-ich-eine-esim-auf-meinem-smartphone-",
          "qrPerEMail": "Im Anschluss wird dir der dazugehörige QR Code hier angezeigt und per Mail gesendet.",
          "showInstructions": "Anleitung ansehen"
        },
        "statusChip": {
          "pausing": "Wird pausiert"
        },
        "suspendedSim": {
          "yourSimSuspended": "Deine SIM wurde gesperrt."
        }
      }
    },
    "loading": "Lädt...",
    "mobileAbo": {
      "name": "Roaming",
      "roamingGoodToKnow": "Das in deinem Mobile Abo inkludierte Roamingvolumen wird immer zuerst verwendet, auch falls du bereits eine reguläre Roamingoption derselben Zone gebucht hast.",
      "roamingGoodToKnowMinuteAllowance": "Dein Minutenguthaben aktualisiert sich mit einer Verzögerung von bis zu 24h. Gesprächsminuten, die über dein Guthaben hinausgehen, werden pro Minute verrechnet."
    },
    "my-subscriptions": {
      "addSubscription": "Abo hinzufügen",
      "viewToggle": {
        "list": "Listenansicht",
        "tiles": "Kachelansicht"
      }
    },
    "personalDataOnboarding": {
      "headline": "Vervollständige dein Profil"
    },
    "subscription-change": {
      "currentTariffLabel": "Aktuell",
      "heading": "Abo ändern",
      "steps": {
        "checkout": {
          "label": "Abschluss"
        }
      }
    },
    "user-account": {
      "billingAccounts": {
        "add": "Empfänger hinzufügen",
        "bulkMove": {
          "description": "Verschiebe mehrere Abos gesammelt von einem Rechnungsempfänger zu einem anderen.",
          "deselectAll": "Alle Abos abwählen",
          "error": "Wir konnten die Abos nicht verschieben. Bitte versuche es erneut.",
          "selectAll": "Alle Abos auswählen",
          "selectHeadline": "1. Abos wählen",
          "selected": "Ausgewählte Abos",
          "success": "Die Abos wurden verschoben.",
          "targetDescription": "Die ausgewählten Abos werden nach der Verschiebung diesem Rechnungsempfänger zugeordnet.",
          "targetHeadline": "2. Ziel-Rechnungsempfänger",
          "title": "Sammelverschiebung"
        },
        "details": {
          "address": "Adresse",
          "note": "Bemerkung",
          "postalAddress": "Anschrift"
        },
        "empty": "Du hast noch keine Rechnungsempfänger hinterlegt.",
        "expand": "Details anzeigen",
        "modal": {
          "create": "Empfänger erstellen",
          "createSuccess": "Der Rechnungsempfänger wurde erstellt.",
          "createTitle": "Rechnungsempfänger hinzufügen",
          "description": "Hinterlege Name, Anschrift, E-Mail und Referenz für diesen Rechnungsempfänger.",
          "editAddress": "Bearbeiten",
          "editTitle": "Rechnungsempfänger bearbeiten",
          "error": "Wir konnten den Rechnungsempfänger nicht speichern. Bitte versuche es erneut.",
          "fields": {
            "additionalAddress": "Adresszusatz",
            "alias": "Bezeichnung",
            "aliasHint": "Erscheint in der Übersicht nach der Rechnungsempfängernummer, damit du den Empfänger schneller zuordnen kannst.",
            "city": "Ort",
            "companyName": "Firmenname",
            "companyOrNameRequired": "Bitte Firmenname oder Name angeben.",
            "email": "E-Mail Adresse",
            "emailHeadline": "E-Mail*",
            "firstName": "Name",
            "lastName": "Nachname",
            "note": "Bemerkung hinzufügen",
            "referenceHeadline": "Referenz*",
            "zip": "PLZ"
          },
          "updateSuccess": "Der Rechnungsempfänger wurde gespeichert."
        },
        "move": {
          "source": "Quelle",
          "submit": "Abos verschieben",
          "target": "Ziel-Rechnungsempfänger wählen"
        },
        "moveModal": {
          "error": "Wir konnten das Abo nicht verschieben. Bitte versuche es erneut.",
          "subscription": "Zuverschiebendes Abo",
          "success": "Das Abo wurde verschoben.",
          "title": "Abo Verschieben"
        },
        "picker": {
          "listHeadline": "Deine Rechnungsempfänger",
          "title": "Rechnungsempfänger wählen"
        },
        "reference": "Referenz",
        "select": {
          "label": "Rechnungsempfänger"
        },
        "subscriptions": {
          "empty": "Diesem Rechnungsempfänger sind keine Abos zugeordnet.",
          "headline": "Zugeordnete Abos",
          "move": "Abo verschieben",
          "moveSelected_one": "{{count}} Abo verschieben",
          "moveSelected_other": "{{count}} Abos verschieben"
        }
      },
      "inbox": {
        "contactlanguage": "Kontaktsprache",
        "marketingSubtitle": "Ich möchte interessante Angebote per E-Mail erhalten.",
        "marketingTitle": "Zusätzliche Informationen",
        "noLanguageSet": "Keine Sprache ausgewählt.",
        "saveError": "Wir konnten deine Änderungen nicht speichern. Probiere es erneut."
      },
      "paymentMethods": {
        "addPaymentMethod": "Hinzufügen",
        "cancel": "abbrechen",
        "change": "ändern",
        "changeSuccessAlert": "Die Änderung des Zahlungsmittels war erfolgreich.",
        "confirmDelete": "Ich bestätige, dass ich mein Zahlungsmittel unwiderruflich löschen möchte.",
        "delete": "löschen",
        "deletePaymentmean": "Zahlungsmittel löschen",
        "deleteSuccessAlert": "Dein Zahlungsmittel wurde erfolgreich gelöscht.",
        "errorAlerts": {
          "generalErrorAlert": "Dein Zahlungsmittel konnte nicht gelöscht werden. Bitte versuche es noch einmal oder wende dich an den Support.",
          "openBill": "Dein Zahlungsmittel konnte nicht gelöscht werden, da du eine oder mehrere offene Rechnungen hast.",
          "outstandingCharges": "Dein Zahlungsmittel konnte nicht gelöscht werden, da die Abrechnung deiner Kosten noch nicht abgeschlossen ist. Bitte wende dich bei Fragen an den Support.",
          "payAsYouGo": "Dein Zahlungsmittel konnte nicht gelöscht werden, da die Abrechnung deiner Kosten noch nicht abgeschlossen ist. Bitte wende dich bei Fragen an den Support.",
          "serviceSettingsOn": "Dein Zahlungsmittel konnte nicht gelöscht werden. Mit deinem Account sind Kosten verknüpft, die noch nicht abgerechnet wurden. Bitte wende dich bei Fragen an den Support."
        },
        "headline": "Deine Zahlungsmittel",
        "invoice": "Rechnung",
        "noPaymentMethod": "Du hast kein Zahlungsmittel hinterlegt.",
        "requestPaymentViaInvoice": "Wenn du die Zahlung per Rechnung beantragen möchtest, folge bitte <0>diesem Link</0>.",
        "requestPaymentViaInvoiceLink": "https://support.digitalrepublic.ch/de/support/tickets/new?ticket_form=firmenkunden_%2F_business_client",
        "title": "Zahlungsmittel"
      },
      "personalDetails": {
        "address": "Anschrift",
        "changeSuccess": "Persönliche Daten erfolgreich gespeichert.",
        "companyData": {
          "editTitle": "Firmen Informationen",
          "title": "Firmendaten"
        },
        "dateOfBirth": "Geburtsdatum",
        "loginData": {
          "accountLocked": "Dein Zugriff ist für 30 Minuten gesperrt. Bitte versuche es später erneut oder setze dein Passwort zurück.",
          "currentEmail": "Aktuelle E-Mail-Adresse",
          "currentEmailError": "Bitte überprüfe deine aktuelle E-Mail-Adresse.",
          "currentPassword": "Bisheriges Passwort",
          "emailChangeSuccess": "E-Mail-Adresse erfolgreich geändert.",
          "emailInUseError": "Es scheint als wäre diese E-Mail schon in Benutzung, bitte benutze eine andere.",
          "emailInvalid": "E-Mail-Adresse nicht valide.",
          "newEmail": "Neue E-Mail-Adresse eingeben",
          "newPassword": "Neues Passwort",
          "passwordChangeSuccess": "Passwort erfolgreich geändert.",
          "passwordEnter": "Passwort eingeben",
          "passwordError": "Falsches Passwort. Bitte überprüfe deine Eingabe.",
          "passwordTitle": "Dein Passwort"
        }
      },
      "security": {
        "2fa": {
          "alerts": {
            "appSetupSuccess": "App-Verifizierung erfolgreich hinterlegt.",
            "smsSetupSuccess": "SMS-Verifizierung erfolgreich hinterlegt."
          },
          "changeOption": "2FA-Anmeldeoption ändern",
          "changePhonenumber": {
            "error": "Die Handynummer ist ungültig. Bitte versuche es erneut.",
            "text": "Du verwendest derzeit die Nummer <0>{{phoneNumber}}</0> für 2FA. Wenn du diese Nummer ändern möchtest, gib bitte die neue Telefonnummer an, unter der du deinen Verifizierungscode erhalten möchtest.",
            "title": "Handynummer ändern"
          },
          "confirmStandard": {
            "error": "Wir konnten dein 2FA nicht entfernen. Probiere es erneut!",
            "steps": {
              "2": {
                "title": "Bestätige mit deinem Namen, dass du die Risiken der Deaktivierung von 2FA verstehst."
              }
            },
            "subtitle": "Deaktivieren und mit Standardanmeldung fortfahren",
            "success": "Dein 2FA wurde entfernt.",
            "text1": "Um die Deaktivierung deiner 2FA-Einstellungen zu bestätigen, unterschreibe bitte unten mit deinem Namen.",
            "text2": "Beachte, dass dein Konto nicht so sicher sein wird, wie es sein sollte.",
            "text3": "Deine Wiederherstellungscodes werden nach der Deaktivierung der 2FA ungültig. Du kannst neue Codes erhalten, wenn du die Einstellungen später erneut aktivierst."
          },
          "description": "Mit 2FA kannst du dein Konto zusätzlich absichern.",
          "disabledBecauseMagicLink": "Mit aktivierter Anmeldung per E-Mail-Link nicht möglich",
          "initialSetup": {
            "title": "2FA-Einstellungen"
          },
          "method": {
            "app": "Authenticator App"
          },
          "modal": {
            "description": "Bitte gib deinen 2FA-Code unten ein, um dich zu verifizieren.",
            "error": "Der Code ist ungültig. Bitte versuche es erneut.",
            "foundYourCode": "Hast du deinen Code gefunden?",
            "recoveryCode": "Wiederherstellungscode",
            "recoveryCodeDescription": "Wenn du den Zugriff auf dein 2FA-Gerät verloren hast, kannst du dich mit einem Wiederherstellungscode anmelden. Bitte bewahre die Wiederherstellungscodes an einem sicheren Ort auf.",
            "recoveryTitle": "Gib deinen Wiederherstellungscode ein",
            "success": "Dein Code ist gültig.",
            "titleApp": "Gib den Bestätigungscode aus deiner Authenticator-App ein",
            "titleSms": "Gib den Bestätigungscode aus der SMS ein",
            "unableToUse": "Verifizierungscode kann nicht verwendet werden?",
            "useUniqueCode": "Wiederherstellungscode verwenden"
          },
          "qrCode": {
            "description": "Scanne den QR-Code oder kopiere deinen Schlüssel mit zusätzlichen Geräten oder Authenticator-Apps. Dies ist besonders nützlich für Kunden, die ihr Konto teilen.",
            "title": "QR-Code für 2FA App"
          },
          "readMore": "Hier erfährst du mehr.",
          "readMoreUrl": "https://support.digitalrepublic.ch/de/support/solutions/articles/33000290331",
          "title": "Zwei-Faktor-Authentifizierung (2FA)"
        },
        "buttons": {
          "activate": "Aktivieren",
          "back": "Zurück",
          "verify": "Verifizieren"
        },
        "magicLink": {
          "description": "Wenn diese Option aktiv ist, kannst du dich mit einem sicheren Link per E-Mail anmelden – ohne Passwort.",
          "disabledBecauseTwoFactor": "Mit aktiviertem 2FA nicht möglich",
          "saveError": "Die Einstellung konnte nicht gespeichert werden. Bitte versuche es erneut.",
          "saveSuccess": "Deine Einstellung wurde gespeichert.",
          "title": "Anmeldung per E-Mail-Link",
          "toggleTitle": "Anmeldung per E-Mail-Link erlauben"
        }
      },
      "tabs": {
        "billingRecipients": "Rechnungsempfänger",
        "inbox": "Benachrichtigungen",
        "paymentMethods": "Zahlungsmittel",
        "security": "Login"
      },
      "title": "Benutzerkonto"
    }
  },
  "translation": {
    "2fa": {
      "setup": {
        "options": {
          "authenticatorApp": {
            "title": "Authenticator App"
          },
          "login": {
            "title": "Standard-Login"
          },
          "not-recommended": "Nicht empfohlen",
          "secure": "Sicher",
          "sms": {
            "title": "SMS-Verifizierung"
          },
          "very-secure": "Sehr sicher"
        }
      }
    },
    "Common": {
      "checkout": {
        "dueOn": "fällig am {{date}}",
        "summary": "Zusammenfassung",
        "thereafter": "Danach"
      },
      "companyName": "Digital Republic AG",
      "days": "Tage",
      "friendsWithBenefits": {
        "businessCustomer": "Geschäftskunden können nicht an Friends with Benefits teilnehmen."
      },
      "generalForm": {
        "error": {
          "genericError": "Etwas ist schiefgelaufen. Wenn der Fehler weiterhin besteht, versuche es bitte in einem privaten Browserfenster.",
          "genericRegexError": "Bitte gib einen gültigen Wert ein"
        },
        "fields": {
          "email": {
            "label": "E-Mail-Adresse"
          },
          "password": {
            "label": "Passwort"
          }
        },
        "validation": {
          "emailNotValid": "Bitte gib eine gültige E-Mail-Adresse ein",
          "emailRequired": "Bitte gib eine E-Mail-Adresse ein",
          "passwordRequired": "Bitte gib ein Passwort ein"
        }
      },
      "label": {
        "back": "zurück",
        "backToLogin": "Zurück zur Anmeldung",
        "cancel": "Abbrechen",
        "change": "Ändern",
        "complete": "abschliessen",
        "continue": "Weiter",
        "delete": "Löschen",
        "finish": "Abschliessen",
        "forward": "weiter",
        "gotIt": "Verstanden",
        "manage": "Verwalten",
        "name": "Name",
        "optional": "(optional)",
        "period": "Zeitraum",
        "personalDetails": "Persönliche Daten",
        "price": "Preis",
        "removeItem": "{{label}} entfernen",
        "save": "Speichern",
        "subscriptionName": "Aboname",
        "toShop": "Zum Shop"
      },
      "language": "Sprache",
      "links": {
        "privacyPolicy": "https://digitalrepublic.ch/de/datenschutz/",
        "rates": "https://digitalrepublic.ch/de/tarifuebersicht/",
        "terms&Conditions": "https://digitalrepublic.ch/de/allgemeine-geschaeftsbedingungen/"
      },
      "logoName": "Digital Republic",
      "nothingFound": "Nichts gefunden.",
      "products": {
        "esim": "eSIM",
        "friendsWithBenefits": "Friends with Benefits",
        "simCard": "SIM-Karte",
        "watchSim": "Watch SIM"
      },
      "requirementStatus": {
        "met": "erfüllt",
        "notMet": "noch nicht erfüllt"
      },
      "selected": "ausgewählt",
      "stepStatus": {
        "done": "erledigt",
        "in-progress": "in Bearbeitung",
        "to-be-done": "offen"
      },
      "support": "Support",
      "tariff": {
        "365days": "365 Tage",
        "dataTelephonySmsCH": "Daten, Telefonie & SMS CH",
        "international": "International",
        "mbitMax": "Mbit/s max.",
        "options": "Abo-Optionen",
        "unlimited": "Unlimitiert",
        "unlimitedLowercase": "unlimitiert",
        "volumeGb": "{{volume}} GB"
      }
    },
    "Content": {
      "goodToKnow": "Good to know",
      "periods": "Zeiträume"
    },
    "Error": {
      "404": {
        "backToThePortal": "Zurück zum Portal",
        "text": "Ups, diese Seite scheint nicht zu existieren. Es tut uns leid, dass du nicht das findest, was du suchst. Zum Glück geht es hier direkt zurück ins Kundenportal.",
        "title": "Error 404"
      },
      "agentLogin": {
        "failed": "Der Login hat nicht geklappt. Probiere es bitte erneut."
      },
      "eSimError": "eSIM Infos konnten nicht geladen werden. Bitte später erneut versuchen.",
      "payment": {
        "expired": "Diese Karte kann leider nicht belastet werden, da das Gültigkeitsdatum erreicht wurde.",
        "expiredZero": "Diese Karte kann leider nicht hinterlegt werden, da das Gültigkeitsdatum erreicht wurde.",
        "fail": "Dein Zahlungsmittel konnte nicht belastet werden.",
        "failZero": "Dein Zahlungsmittel konnte nicht hinterlegt werden.",
        "notValid": "Die Kartennummer ist leider nicht gültig. Bitte kontrolliere deine Eingabe und versuche es noch einmal.",
        "pleaseCheckData": "Bitte überprüfe deine Daten oder wende dich an den Anbieter deines Zahlungsmittels.",
        "pleaseCheckInput": "Bitte kontrolliere deine Eingabe oder versuche es mit einem anderen Zahlungsmittel."
      },
      "roamingError": "Roaming-Daten konnten nicht geladen werden. Bitte später erneut versuchen."
    },
    "Footer": {
      "customerNumber": "Kundennummer:",
      "customerPortal": {
        "label": "Kundenportal"
      },
      "dataProtection": {
        "label": "Datenschutzerklärung"
      },
      "disclaimer": {
        "label": "Haftungsausschluss",
        "url": "https://digitalrepublic.ch/de/haftungsausschluss-geistiges-eigentum/"
      },
      "imprint": {
        "label": "Impressum",
        "url": "https://digitalrepublic.ch/de/impressum/"
      },
      "linksNavAriaLabel": "Footer-Links",
      "partnerPortal": {
        "label": "Partnerportal"
      },
      "privacySettings": {
        "label": "Datenschutzeinstellungen"
      },
      "socialLinksNavAriaLabel": "Social-Media-Links",
      "support": {
        "url": "https://support.digitalrepublic.ch/"
      },
      "termsConditions": {
        "label": "AGBs"
      },
      "website": {
        "label": "Website",
        "url": "https://digitalrepublic.ch/"
      }
    },
    "Header": {
      "welcomeHeadline": "Willkommen im Kundenportal"
    },
    "Icons": {
      "connection": "Verbindung",
      "speed": "Geschwindigkeit"
    },
    "Languages": {
      "english": "Englisch",
      "french": "Französisch",
      "german": "Deutsch",
      "language": "Sprache"
    },
    "Onboarding": {
      "sections": {
        "checkout": {
          "acceptTerms": "Ja, ich bin mit den <0>Geschäftsbedingungen</0> einverstanden und möchte meine Bestellung abschliessen.",
          "alreadyAddedPaymentData": "Bereits hinterlegtes Zahlungsmittel.",
          "basketErrors": {
            "basketReloaded": "Deine Bestellung konnte nicht abgeschlossen werden und wurde neu geladen. Bitte prüfe die Angaben und schliesse die Bestellung erneut ab.",
            "iccidMissing": "Deiner Bestellung ist keine SIM-Karte zugeordnet. Bitte erfasse deine SIM-Karte erneut.",
            "mnpDataMissing": "Die Angaben zur Rufnummernportierung fehlen. Bitte erfasse sie erneut.",
            "totalAmountChanged": "Der Gesamtbetrag deiner Bestellung hat sich geändert. Bitte prüfe den aktualisierten Betrag und schliesse die Bestellung erneut ab."
          },
          "billingAccount": {
            "description": "Bitte wähle einen vorhandenen Rechnungsempfänger aus oder füge einen neuen hinzu.",
            "editHint": "Möchtest du einen bestehenden Rechnungsempfänger bearbeiten? Das geht unter <0>Rechnungsempfänger</0>.",
            "title": "Abrechnung"
          },
          "billingPeriod": {
            "description": "Bei jährlicher Zahlung ist ein Monat gratis.",
            "freeMonthBadge": "1 Monat gratis",
            "monthly": "Monatlich",
            "title": "Lieber jährlich bezahlen?",
            "yearly": "Jährlich"
          },
          "choosePayment": "Wähle ein Zahlungsmittel für diese Zahlung aus. Bitte stelle sicher, dass 3D-Secure für deine Kreditkarte eingeschaltet ist.",
          "loading": "Dein Auftrag wird gerade verarbeitet.",
          "noCharge": "Für die Aktivierung deines Abos muss aus Sicherheitsgründen ein Zahlungsmittel hinterlegt werden. Hast du dein Abo bereits bezahlt, werden wir dein Zahlungsmittel nicht belasten.",
          "paymentData": "Zahlungsmittel",
          "subtitleWhileHandling": "Deine Zahlung wird verarbeitet, einen Augenblick bitte.",
          "summary": {
            "billingPeriod": "{{days}} Tage",
            "callsTitle": "Anrufe EU/USA",
            "callsVolumeMinutes": "{{volume}} Min.",
            "changeRate": "ändern",
            "credit": "Guthaben",
            "dataRoamingTitle": "Daten-Roaming EU/USA",
            "defaultNames": {
              "dataPlan04": "Mein Flat 0.4",
              "dataPlan1": "Mein Flat 1",
              "dataPlan10": "Mein Flat 10",
              "dataPlan2000": "Mein Flat 2000",
              "dataPlan300": "Mein Flat 300",
              "dataPlan50": "Mein Flat 50",
              "flatMobileOne": "Mein Flat Mobile One",
              "flatMobileThree": "Mein Flat Mobile Three",
              "flatMobileTwo": "Mein Flat Mobile Two",
              "homeInternet4G": "Home Internet 4G",
              "homeInternet5G": "Home Internet 5G"
            },
            "deviceName": "Gerätename",
            "deviceNamePlaceholder": "Alina's iPhone",
            "deviceType": "Gerätetyp",
            "discount": "Rabatt",
            "durationDays_one": "{{count}} Tag Laufzeit",
            "durationDays_other": "{{count}} Tage Laufzeit",
            "durationMonths_one": "{{count}} Monat Laufzeit",
            "durationMonths_other": "{{count}} Monate Laufzeit",
            "errorDeviceName": "Bitte gib einen gültigen Gerätenamen ein (mind. 3 Zeichen).",
            "errorDeviceType": "Bitte wähle einen Gerätetyp aus.",
            "esimHintText": "Deine eSIM wird nach der Verifizierung deiner Identität im Portal zur Verfügung stehen.",
            "internationalRestriction": "Zur Nutzung von Roaming-Telefonie muss ein von der Schweiz ausgestelltes Identitätsdokument (Pass/ID oder Ausländerausweis) beim ID Check verwendet werden.",
            "newNumberHint": "Du erhältst eine neue Rufnummer.",
            "newNumberTitle": "Neue Rufnummer",
            "nextDueOn": "Ab {{date}}",
            "numberPortingIncluded": "inkl. Nummernportierung",
            "numberPortingNotIncluded": "ohne Nummernportierung",
            "payOnce": "<0>Jetzt</0> zu bezahlen",
            "payOnceValue": "<0>Jetzt</0> zu bezahlen {{total}}",
            "payReoccuring": "<0>Alle {{days}} Tage</0> zu bezahlen",
            "portedNumberHint": "Diese Rufnummer wird mitgenommen.",
            "portedNumberTitle": "Bestehende Rufnummer",
            "recurringCaption": "alle {{days}} Tage",
            "startingAfterPorting": "Nach der Portierung",
            "startingOn": "ab {{date}}",
            "subtotal": "Zwischensumme",
            "switzerlandDataOnlyTitle": "Daten 5G",
            "taxIncluded": "inkl. 8.1% MWST",
            "total": "Summe",
            "until_date": "(bis <0>{{date}}</0>)",
            "voiceOptionIncluded": "inkl. Voice Option",
            "voiceOptionNotIncluded": "ohne Voice Option"
          }
        },
        "number-porting": {
          "afterContractEnds": "Nach Vertragsende",
          "beforeContractEnds": "Vorzeitige Vertragskündigung",
          "chooseWishDate": "Wunschtermin auswählen",
          "completed": "Nummernportierung abgeschlossen",
          "cost-warning": "Ggfs. fallen von deinem Provider Zusatzkosten an. Die Höhe wird von dem Provider festgelegt und dir in Rechnung gestellt.",
          "currentContractType": "Bisheriger Vertragstyp",
          "currentNumber": "Bisherige Rufnummer",
          "currentProvider": "Bisheriger Anbieter",
          "hintTitle": "Hinweis",
          "msisdnAlreadyInUse": "Die Rufnummer ist bereits im System vorhanden und kann nicht registriert werden.",
          "msisdnSuspended": "Die Rufnummer ist gesperrt und kann nicht übertragen werden.",
          "numberFormat": "Nummer sollte im Format +41 (0) xx xxx xx xx eingegeben werden.",
          "placeholder": {
            "currentNumber": "`+41 (0) __ ___ __ __",
            "currentProvider": "Wähle einen Anbieter aus",
            "wishDate": "JJJJ-MM-TT"
          },
          "postpaid": "Abonnement (monatliche Rechnung)",
          "prepaid": "Prepaid (Guthaben)",
          "recommended": "empfohlen",
          "steps": "Wir werden die nötigen Schritte einleiten. Du musst beim bisherigen Anbieter nicht selbst kündigen.",
          "subHeadline": "Damit wir die Übernahme deiner Rufnummer anstossen können, musst du uns lediglich die Details deines aktuellen Mobilfunkproviders mitteilen. Keine Sorge, die Portierung findet erst statt, wenn du es wünschst.",
          "termination": "Kündigung",
          "title": "Nummernportierung"
        },
        "personal-details": {
          "disabledFieldsHint": "Wenn du die inaktiven Felder deiner persönlichen Angaben ändern möchtest, kannst du dich an den <0>Support</0> wenden.",
          "form": {
            "formOfAddress": {
              "mr": "Herr",
              "mrs": "Frau",
              "other": "Keine Angabe"
            },
            "hint": {
              "firstName": "Vorname gemäss Ausweisdokument",
              "lastName": "Nachname gemäss Ausweisdokument"
            },
            "label": {
              "addressSupplement": "Adresszusatz",
              "city": "Stadt",
              "company-street": "Strasse (Firmensitz)",
              "country": "Land",
              "dateOfBirth": "Geburtsdatum*",
              "firstName": "Vorname gemäss Ausweisdokument",
              "formOfAddress": "Anrede",
              "houseNumber": "Nr.",
              "isBusinessAccount": "Ich nutze das Konto geschäftlich",
              "lastName": "Nachname gemäss Ausweisdokument",
              "organizationForm": "Unternehmensform",
              "organizationId": "Unternehmens-ID",
              "organizationName": "Firmenname",
              "phone": "Telefonnummer für Rückfragen",
              "street": "Strasse",
              "zip": "PLZ"
            },
            "legalForms": {
              "1": "Einzelfirma",
              "10": "Stiftung",
              "11": "Öffentlich-rechtliche Körperschaft",
              "2": "Einfache Gesellschaft",
              "3": "Kollektivgesellschaft",
              "4": "Kommanditgesellschaft",
              "5": "AG",
              "6": "GmbH",
              "7": "Kommandit-AG",
              "8": "Genossenschaft",
              "9": "Verein"
            },
            "placeholder": {
              "dateOfBirth": "Geburtstag (TT.MM.JJJJ)",
              "organizationId": "Unternehmens-ID (UID)"
            },
            "validation": {
              "organizationId": "Bitte überprüfe die eingegebene UID."
            }
          },
          "friendsWithBenefitsPopUp": {
            "cta1": "Privates Konto erstellen",
            "cta2": "Gruppe verlassen",
            "text2": "Wenn du ein Geschäftskonto einrichtest, wirst du aus der Gruppe entfernt.",
            "text3": "Falls du als Geschäftskunde dennoch von Mengenrabatten profitieren möchtest, kannst du dich an unser Support- oder Verkaufsteam wenden.",
            "title": "Achtung!"
          }
        },
        "rate-selection": {
          "dontTakeNumber": "<strong>Nein</strong>, ich möchte eine <strong>neue</strong> Rufnummer.",
          "download": "Download",
          "mbitPerSecond": "{{value}} Mbit/s",
          "numberPortingHint": "Diese Option kannst du  <0>nicht</0> zu einem späteren Zeitpunkt nachholen.",
          "perMonth": "CHF pro Monat",
          "prechargedRateHint": "Dieses Abo kannst du nach der Laufzeit gerne im Kundenportal anpassen.",
          "roamingVolumeWithCalls": "{{volume}} GB + {{minutes}} Min.",
          "roamingVolumeWithUnlimitedCalls": "{{volume}} GB + ∞ Min.",
          "roamingZone": "in EU/USA",
          "tabs": {
            "dataOnly": "Data-only",
            "mobileAbos": "Mobile Abos"
          },
          "tariffHint": "Alle unsere Abos sind <0>in der Schweiz</0> für Daten <1>unlimitiert</1>.",
          "upload": "Upload",
          "yesTakeNumber": "<strong>Ja</strong>, ich möchte meine <strong>bisherige</strong> Rufnummer beibehalten."
        },
        "sim-selection": {
          "dunningProcessOpenText": "Du kannst derzeit keine weiteren Abos hinzufügen, da dein Konto im Mahnprozess ist. Bitte begleiche offene Rechnungen, um fortzufahren.",
          "homepageLink": "https://digitalrepublic.ch/de/",
          "noSimCardText": "Bestelle eine SIM-Karte in unserem Shop, um mit der Aktivierung loslegen zu können.",
          "noSimCardTitle": "Du hast noch keine SIM-Karte?",
          "shopLink": "https://digitalrepublic.ch/de/shop/?utm_source=aax_dr&utm_medium=reorder_link&utm_campaign=aax_reorder",
          "upgradeSimLimit": "Limit erhöhen",
          "upgradeSimLimitLink": "https://support.digitalrepublic.ch/de/support/solutions/articles/33000287898-wie-kann-ich-die-maximale-anzahl-sim-s-erh%C3%B6hen"
        },
        "sim-verification": {
          "hint": {
            "header": "SIM- und PUK-Nummer",
            "text": "Du findest deine SIM-Nummer (ICCID) und deinen PUK aufgedruckt auf deiner SIM-Karte."
          },
          "iccid": {
            "helpHint": "Wo finde ich es?",
            "label": "Deine SIM-Nummer",
            "placeholder": "Gib deine SIM-Nummer ein",
            "validation": {
              "badFormat": "Bitte gib die 20 Stellen deiner SIM-Nummer ein.",
              "invalid": "Die eingegebene SIM-Nummer konnte nicht zugeordnet werden."
            }
          },
          "puk": {
            "label": "Dein PUK",
            "placeholder": "Gib deinen PUK ein",
            "validation": {
              "badFormat": "Bitte gib deinen 8-stellige PUK ein.",
              "rejected": "Der eingegebene PUK scheint nicht richtig zu sein."
            }
          },
          "scanner": {
            "button": "Strichcode scannen",
            "cameraError": "Kamera konnte nicht geöffnet werden. Bitte überprüfe die Kamera-Berechtigung.",
            "hint": "Halte den Strichcode deiner SIM-Karte in den markierten Bereich.",
            "noBarcode": "Kein Strichcode erkannt. Bitte versuche es erneut.",
            "scan": "Jetzt scannen",
            "scanning": "Wird gescannt…",
            "title": "SIM-Nummer scannen"
          },
          "simAliasFlatHome": "Mein Flat Home",
          "subtitle": "SIM Verifizierung Untertitel"
        }
      }
    },
    "Tile": {
      "label": {
        "activateSim": "SIM-Karte\naktivieren"
      }
    },
    "billingActionBlocked": {
      "text": "Aufgrund eines laufenden Rechnungslaufs oder deiner Kontoeinstellungen können Rechnungsempfänger gerade nicht erstellt, bearbeitet oder Abos verschoben werden. Ein Rechnungslauf kann bis zu 24 Stunden dauern. Bitte versuche es später erneut.",
      "title": "Änderung momentan nicht möglich"
    },
    "clipboardField": {
      "copy": "Kopieren"
    },
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Åland",
      "ALB": "Albanien",
      "AND": "Andorra",
      "ARE": "Vereinigte Arabische Emirate",
      "ARG": "Argentinien",
      "ARM": "Armenien",
      "ASM": "Amerikanisch-Samoa",
      "ATA": "Antarktika",
      "ATF": "Französische Süd- und Antarktisgebiete",
      "ATG": "Antigua und Barbuda",
      "AUS": "Australien",
      "AUT": "Österreich",
      "AZE": "Aserbaidschan",
      "BDI": "Burundi",
      "BEL": "Belgien",
      "BEN": "Benin",
      "BES": "Bonaire, Sint Eustatius und Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesch",
      "BGR": "Bulgarien",
      "BHR": "Bahrain",
      "BHS": "Bahamas",
      "BIH": "Bosnien und Herzegowina",
      "BLM": "Saint-Barthélemy",
      "BLR": "Weissrussland",
      "BLZ": "Belize",
      "BMU": "Bermuda",
      "BOL": "Bolivien",
      "BRA": "Brasilien",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhutan",
      "BVT": "Bouvetinsel",
      "BWA": "Botswana",
      "CAF": "Zentralafrika",
      "CAN": "Kanada",
      "CCK": "Kokosinseln",
      "CHE": "Schweiz",
      "CHL": "Chile",
      "CHN": "China",
      "CIV": "Elfenbeinküste",
      "CMR": "Kamerun",
      "COD": "Kongo (Kinshasa))",
      "COG": "Kongo (Brazzaville)",
      "COK": "Cookinseln",
      "COL": "Kolumbien",
      "COM": "Komoren",
      "CPV": "Kap Verde",
      "CRI": "Costa Rica",
      "CUB": "Kuba",
      "CUW": "Curaçao",
      "CXR": "Weihnachtsinsel",
      "CYM": "Kaimaninseln",
      "CYP": "Zypern",
      "CZE": "Tschechische Republik",
      "DEU": "Deutschland",
      "DJI": "Dschibuti",
      "DMA": "Dominica",
      "DNK": "Dänemark",
      "DOM": "Dominikanische Republik",
      "DZA": "Algerien",
      "ECU": "Ecuador",
      "EGY": "Ägypten",
      "ERI": "Eritrea",
      "ESH": "Westsahara",
      "ESP": "Spanien",
      "EST": "Estland",
      "ETH": "Äthiopien",
      "FIN": "Finnland",
      "FJI": "Fidschi",
      "FLK": "Falklandinseln",
      "FRA": "Frankreich",
      "FRO": "Färöer",
      "FSM": "Mikronesien",
      "GAB": "Gabun",
      "GBR": "Grossbritannien (und Nordirland)",
      "GEO": "Georgien",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinea",
      "GLP": "Guadeloupe",
      "GMB": "Gambia",
      "GNB": "Guinea-Bissau",
      "GNQ": "Äquatorialguinea",
      "GRC": "Griechenland",
      "GRD": "Grenada",
      "GRL": "Grönland",
      "GTM": "Guatemala",
      "GUF": "Französisch-Guayana",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hongkong",
      "HMD": "Heard und McDonaldinseln",
      "HND": "Honduras",
      "HRV": "Kroatien",
      "HTI": "Haiti",
      "HUN": "Ungarn",
      "IDN": "Indonesien",
      "IMN": "Isle of Man",
      "IND": "Indien",
      "IOT": "Britisches Territorium im Indischen Ozean",
      "IRL": "Irland",
      "IRN": "Iran",
      "IRQ": "Irak",
      "ISL": "Island",
      "ISR": "Israel",
      "ITA": "Italien",
      "JAM": "Jamaika",
      "JEY": "Jersey",
      "JOR": "Jordanien",
      "JPN": "Japan",
      "KAZ": "Kasachstan",
      "KEN": "Kenia",
      "KGZ": "Kirgisistan",
      "KHM": "Kambodscha",
      "KIR": "Kiribati",
      "KNA": "St. Kitts and Nevis",
      "KOR": "Südkorea",
      "KWT": "Kuwait",
      "LAO": "Laos",
      "LBN": "Libanon",
      "LBR": "Liberia",
      "LBY": "Libyen",
      "LCA": "St. Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Litauen",
      "LUX": "Luxemburg",
      "LVA": "Lettland",
      "MAC": "Macao",
      "MAF": "Saint-Martin (franz. Teil)",
      "MAR": "Marokko",
      "MCO": "Monaco",
      "MDA": "Moldawien",
      "MDG": "Madagaskar",
      "MDV": "Malediven",
      "MEX": "Mexiko",
      "MHL": "Marshallinseln",
      "MKD": "Mazedonien",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolei",
      "MNP": "Nördliche Marianen",
      "MOZ": "Mosambik",
      "MRT": "Mauretanien",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Malaysia",
      "MYT": "Mayotte",
      "NAM": "Namibia",
      "NCL": "Neukaledonien",
      "NER": "Niger",
      "NFK": "Norfolkinsel",
      "NGA": "Nigeria",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Niederlande",
      "NOR": "Norwegen",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NZL": "Neuseeland",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCN": "Pitcairninseln",
      "PER": "Peru",
      "PHL": "Philippinen",
      "PLW": "Palau",
      "PNG": "Papua-Neuguinea",
      "POL": "Polen",
      "PRI": "Puerto Rico",
      "PRK": "Nordkorea",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Palästina",
      "PYF": "Französisch-Polynesien",
      "QAT": "Katar",
      "REU": "Réunion",
      "ROU": "Rumänien",
      "RUS": "Russland",
      "RWA": "Ruanda",
      "SAU": "Saudi-Arabien",
      "SDN": "Sudan",
      "SEN": "Senegal",
      "SGP": "Singapur",
      "SGS": "Südgeorgien und die Südlichen Sandwichinseln",
      "SHN": "St. Helena",
      "SJM": "Spitzbergen und Jan Mayen",
      "SLB": "Salomonen",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalia",
      "SPM": "Saint-Pierre und Miquelon",
      "SRB": "Serbien",
      "SSD": "Südsudan",
      "STP": "São Tomé und Príncipe",
      "SUR": "Suriname",
      "SVK": "Slowakei",
      "SVN": "Slowenien",
      "SWE": "Schweden",
      "SWZ": "Swasiland",
      "SXM": "Sint Maarten (niederl. Teil)",
      "SYC": "Seychellen",
      "SYR": "Syrien",
      "TCA": "Turks- und Caicosinseln",
      "TCD": "Tschad",
      "TGO": "Togo",
      "THA": "Thailand",
      "TJK": "Tadschikistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "Osttimor",
      "TON": "Tonga",
      "TTO": "Trinidad und Tobago",
      "TUN": "Tunesien",
      "TUR": "Türkei",
      "TUV": "Tuvalu",
      "TWN": "Taiwan",
      "TZA": "Tansania",
      "UGA": "Uganda",
      "UKR": "Ukraine",
      "UMI": "United States Minor Outlying Islands",
      "URY": "Uruguay",
      "USA": "USA",
      "UZB": "Usbekistan",
      "VAT": "Vatikanstadt",
      "VCT": "St. Vincent und die Grenadinen",
      "VEN": "Venezuela",
      "VGB": "Britische Jungferninseln",
      "VIR": "Amerikanische Jungferninseln",
      "VNM": "Vietnam",
      "VUT": "Vanuatu",
      "WLF": "Wallis und Futuna",
      "WSM": "Samoa",
      "XKX": "Kosovo",
      "YEM": "Jemen",
      "ZAF": "Südafrika",
      "ZMB": "Sambia",
      "ZWE": "Simbabwe"
    },
    "label": {
      "hidePassword": "Passwort verbergen",
      "hint": {
        "newPassword": "Dein Passwort muss Gross- und Kleinbuchstaben, Sonderzeichen, Zahlen und 8-30 Zeichen enthalten.",
        "password": "Bestätige deine neue E-Mail-Adresse mit deinem Passwort."
      },
      "showPassword": "Passwort anzeigen",
      "validation": {
        "email": "Bitte gib eine gültige E-Mail-Adresse an.",
        "invalidBirthdate": "Bitte gib ein gültiges Geburtsdatum ein.",
        "maxLength": "Du hast die Maximallänge von {{max}} Zeichen überschritten.",
        "password": "Passwort ungültig. Dein Passwort muss Gross- und Kleinbuchstaben, Sonderzeichen, Zahlen und 8-30 Zeichen enthalten.",
        "phone": "Bitte gib deine Handynummer im Format +xxxxxxxxxxx ein.",
        "phoneBackend": "Die Handynummer ist ungültig. Bitte überprüfe deine Eingabe.",
        "phoneNoPlus": "Deine Telefonnummer muss mit 07 oder 00 starten.",
        "required": "Dies ist ein Pflichtfeld.",
        "zip": "Bitte gib eine gültige Postleitzahl ein."
      }
    },
    "links": {
      "isMyDeviceESIMCompatible": "https://support.digitalrepublic.ch/de/support/solutions/articles/33000256600-besitze-ich-ein-esim-f%C3%A4higes-ger%C3%A4t-",
      "supportHomeLink": "https://support.digitalrepublic.ch/de/support/home"
    },
    "newWelcome": {
      "initialPasswordSetup": {
        "confirmPasswordLabel": "Neues Passwort wiederholen",
        "errors": {
          "genericError": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
          "unauthorized": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut über den Link in deiner E-Mail an.",
          "userNotFound": "Wir konnten dein Konto nicht finden. Bitte melde dich erneut über den Link in deiner E-Mail an."
        },
        "headline": "Willkommen bei Digital Republic",
        "passwordLabel": "Neues Passwort",
        "title": "Passwort erstellen"
      },
      "logInForm": {
        "forgotPassword": "Passwort vergessen?",
        "invalidCredentialsError": "Falsches Passwort oder falsche E-Mail-Adresse",
        "noAccount": "Du hast noch kein Konto?",
        "registerNow": "Jetzt registrieren",
        "submitButton": "Anmelden"
      },
      "magicLink": {
        "errors": {
          "consumeFailed": "Die Anmeldung ist fehlgeschlagen. Bitte versuche es erneut oder melde dich mit deinem Passwort an.",
          "expiredLink": "Dieser Link ist abgelaufen. Fordere auf dem Anmeldebildschirm einen neuen Anmeldelink an.",
          "invalidLink": "Dieser Anmeldelink ist ungültig",
          "notAllowed": "Die Anmeldung per E-Mail-Link ist für dein Konto nicht aktiviert. Du kannst dies in den Einstellungen ändern.",
          "rateLimited": "Du hast zu viele Anmeldelinks angefordert. Bitte versuche es später erneut.",
          "requestFailed": "Die Anmeldung per E-Mail-Link ist momentan nicht möglich. Bitte versuche es später erneut oder melde dich mit deinem Passwort an.",
          "usedLink": "Dieser Link wurde bereits verwendet"
        },
        "linkOnLogin": "Per E-Mail-Link anmelden",
        "request": {
          "backToPasswordLogin": "Mit Passwort anmelden",
          "description": "Gib deine E-Mail-Adresse ein. Wir senden dir einen sicheren Link, mit dem du dich im Kundenportal anmelden kannst.",
          "title": "Anmelden"
        },
        "sent": {
          "message": "Falls ein Konto mit dieser E-Mail-Adresse existiert, erhältst du in Kürze eine E-Mail mit einem Anmeldelink. Aus Sicherheitsgründen ist der Link nur kurze Zeit gültig."
        }
      },
      "registerForm": {
        "acceptTerms": "<1>Datenschutzbestimmungen</1> und <2>AGB</2> akzeptieren *",
        "accountExists": "Du hast bereits ein Konto?",
        "confirmPassword": {
          "label": "Passwort bestätigen"
        },
        "error": {
          "emailAlreadyInUse": "Ein Konto mit dieser E-Mail-Adresse existiert bereits",
          "invalidEmailFormat": "Dieses E-Mail-Adressformat wird nicht unterstützt. Bitte gib eine gültige E-Mail-Adresse ein."
        },
        "logInNow": "Jetzt anmelden",
        "passwordHint": "Dein Passwort muss folgende Kriterien erfüllen:",
        "passwordRequirements": {
          "disallowedCharacter": "Dieses Zeichen ist nicht erlaubt: {{character}}",
          "disallowedCharacters": "Diese Zeichen sind nicht erlaubt: {{characters}}",
          "minLength": "8-30 Zeichen",
          "numberRequired": "Mindestens eine Ziffer (0-9)",
          "spaceCharacter": "Leerzeichen",
          "specialCharacter": "Mindestens ein Sonderzeichen (=+-^$*.[]{}()?\"!@#%&/\\,><':;|_~`)",
          "upperLowercase": "Mindestens ein Klein- und ein Grossbuchstabe (a–z, A–Z)"
        },
        "title": "Registrieren",
        "uiFeedback": {
          "registrationSuccess": "Dein Konto wurde erfolgreich erstellt"
        },
        "validation": {
          "acceptTerms": "Bitte akzeptiere die AGB und Datenschutzbestimmungen",
          "confirmPasswordRequired": "Bitte bestätige dein Passwort",
          "passwordNoMatch": "Die Passwörter stimmen nicht überein"
        }
      }
    },
    "sessionExpired": {
      "text": "Aus Sicherheitsgründen wurdest du ausgeloggt",
      "title": "Deine Sitzung ist abgelaufen"
    }
  }
}
